import { jsx as e, jsxs as p, Fragment as X } from "react/jsx-runtime";
import { withManagedProps as P } from "@made-people/managed-props";
import { z as t } from "zod";
import { withZod as y } from "@made-people/react-prop-guard";
import R, { useEffect as U, useState as $, isValidElement as Yt, useRef as Ee, useCallback as Ge, useMemo as Xt } from "react";
import { p as Qt, a as Zt, b as Z, c as qt, s as Jt, d as ea, e as ta, f as aa, g as na, h as sa, i as oa, j as ia, k as ra, l as la, m as ca, n as da, o as ua, q as pa, r as ma, t as ha, u as ba, v as Ce, w as ga, x as fa, y as va, z as Pa, A as ya, B as Sa, C as wa, D as _a, E as ka, F as Na, G as Ta, H as Ca, I as Aa, J as ge } from "./blueprint-572e03d6.mjs";
import { Drawer as W } from "@made-people/blueprint-drawer";
import * as le from "@radix-ui/react-dialog";
import { useOverlayState as Ba, overlayEventEmitter as ce } from "@made-people/blueprint-overlay";
import { useProductBase as E, ProductLink as Pe, useProductAttributeGetter as ee, useProductPriceInfo as ye, useProductDataModel as Q, useBundlePurchaseInfo as Ae, useProductImages as Da, useMediaAttributeGetter as Oe, useRelatedProducts as Be, ProductProvider as je, filterMediaOnAttributeValues as Je, useProductSpecificationGroup as Ia, useProductAttribute as K, useProductPurchaseStatus as De, useProductOptions as Me, useProductSiblings as et, useBundleOptions as Ke, useBundleItemId as za, useBundlePurchaseStatus as La, useProductHasOptionsInStock as xa } from "@made-people/grease-product";
import { useTranslate as I } from "@made-people/grease-translations";
import Ra from "clsx";
import { accordionItemSchema as Ea, accordionSchema as Ga, Accordion as Wa } from "@made-people/blueprint-accordion";
import { useKeenSlider as Qe } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";
import { ResponsiveImage as te, responsiveImageSchema as tt } from "@made-people/blueprint-responsive-image";
import { useBreakpointVisibility as Oa } from "@made-people/blueprint-ui-hooks";
import { responsiveVideoSchema as ja, ResponsiveVideo as at } from "@made-people/blueprint-responsive-video";
import { MIX_AND_MATCH_IMAGE_ATTRIBUTE_KEY as nt } from "@made-people/blueprint-mix-and-match";
import { badgeSchema as st, Badge as He } from "@made-people/blueprint-badge";
import { CartEventAdditionalDataProvider as Ma, useUpdateCart as Ie, useCartMethod as Ka } from "@made-people/grease-cart";
import { uiEventEmitter as Ha } from "@made-people/grease-ui-events";
import { Heading as Va } from "@made-people/blueprint-heading";
import { isNotUndefined as Ua } from "@made-people/typeguards-common";
import { motion as J, AnimatePresence as de, cubicBezier as ot } from "motion/react";
import { linkAsLinkSchema as $a, Link as Fa, LinkAsLink as Ya, linkAsButtonSchema as Xa, LinkAsButton as Qa } from "@made-people/blueprint-link";
import { buttonContentPropsSchema as ue, ButtonAsButton as fe, Button as se, buttonAsButtonSchema as We, ButtonAsSpan as it, buttonAsSpanSchema as Za } from "@made-people/blueprint-button";
import { toast as qa } from "sonner";
import { productCardSchema as Ja, ProductCard as en } from "@made-people/blueprint-product-card";
import { SearchResultProvider as rt, useSearchResultItems as tn } from "@made-people/grease-search";
import { swipeableProductListSchema as lt, SwipeableProductList as an } from "@made-people/blueprint-swipeable-product-list";
import { Markdown as nn } from "@made-people/blueprint-markdown";
import { GridContext as sn } from "@made-people/blueprint-grid";
import { Breadcrumbs as oe, breadcrumbsSchema as on } from "@made-people/blueprint-breadcrumbs";
import { shippingBarometerSchema as rn, ShippingBarometer as ln } from "@made-people/blueprint-shipping-barometer";
import { NotifyMe as ct } from "@made-people/blueprint-notify-me";
import { StatusInformationIcon as cn } from "@made-people/blueprint-icons";
import { useLink as dn } from "@made-people/grease-link";
import "@made-people/blueprint";
const un = () => /* @__PURE__ */ e(
  "svg",
  {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12.9 12.9",
    children: /* @__PURE__ */ e("path", { d: "M7.5,6.5L12.7,1.3c.3-.3.3-.8,0-1.1s-.8-.3-1.1,0l-5.2,5.2L1.3.2C1,0,.5,0,.2.2s-.2.3-.2.5,0,.4.2.5l5.2,5.2L.2,11.6c-.3.3-.3.8,0,1.1s.3.2.5.2.4,0,.5-.2l5.2-5.2,5.2,5.2c.1.1.3.2.5.2s.4,0,.5-.2.2-.3.2-.5,0-.4-.2-.5l-5.2-5.2Z" })
  }
), pn = ({
  children: a,
  CloseIcon: s,
  slots: n
}) => {
  const { isOpen: o, onChange: i } = Ba();
  return U(() => {
    i(!0);
  }, []), /* @__PURE__ */ e(le.Root, { defaultOpen: !0, onOpenChange: i, open: o, children: /* @__PURE__ */ p(le.Portal, { children: [
    /* @__PURE__ */ e(le.Overlay, { className: n.modalOverlay }),
    /* @__PURE__ */ p(
      le.Content,
      {
        "aria-description": "Product Page Modal",
        "aria-describedby": "Product",
        className: n.modalContent,
        children: [
          /* @__PURE__ */ e(le.Title, { hidden: !0, children: "Product Page" }),
          /* @__PURE__ */ e(le.Close, { className: n.closeButton, children: s }),
          /* @__PURE__ */ e("section", { className: n.contentWrapper, children: a })
        ]
      }
    )
  ] }) });
}, dt = t.object({
  template: t.literal("drawer"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.union([
    t.string(),
    t.custom(),
    t.custom()
  ]).optional()
}), mn = P(
  "ProductDrawer",
  y(
    dt,
    ({ variants: a, children: s, closeIcon: n = un, drawerSettings: o }) => {
      const i = Qt.styles(a), [c, r] = $(!1);
      U(() => {
        r(window.innerWidth > 1124);
      }, []);
      const l = () => typeof n == "string" || Yt(n) ? n : typeof n == "function" ? /* @__PURE__ */ e(n, {}) : null;
      return c ? /* @__PURE__ */ e(pn, { CloseIcon: l(), slots: i, children: s }) : /* @__PURE__ */ e(
        W,
        {
          ...o,
          defaultOpen: !0,
          direction: "bottom",
          variants: {
            dimmed: "subtle",
            blurred: "subtle",
            background: "none",
            ...o == null ? void 0 : o.variants
          },
          children: /* @__PURE__ */ p(
            W.Content,
            {
              contentSettings: {
                "aria-description": "Content for product popup",
                "aria-describedby": "Product"
              },
              children: [
                /* @__PURE__ */ e(W.Close, { className: i.closeButton, children: l() }),
                /* @__PURE__ */ e(W.Title, { hidden: !0, children: "Product Page popup" }),
                /* @__PURE__ */ e("div", { className: i.drawerWrapper, children: /* @__PURE__ */ e("section", { className: i.contentWrapper, children: s }) })
              ]
            }
          )
        }
      );
    }
  )
), ut = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  children: t.custom(() => !0).optional()
}), hn = P(
  "ProductGrid",
  y(ut, ({ variants: a, children: s }) => {
    const n = Zt.styles(a);
    return /* @__PURE__ */ e("section", { className: n.base, children: s });
  })
), bn = t.discriminatedUnion("template", [
  dt,
  ut
]), gn = P(
  "ProductRoot",
  y(bn, (a) => a.template === "drawer" ? /* @__PURE__ */ e(mn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(hn, { ...a }) : null)
), pt = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  blueprint: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  asLink: t.boolean().optional()
}), fn = P(
  "ProductDetailsName",
  y(
    {
      schema: pt,
      defaultProps: {
        headingTag: "h1"
      }
    },
    ({ variants: a, text: s, headingTag: n, asLink: o, ...i }) => {
      const c = E(), {
        content: { name: r }
      } = c, u = (i.blueprint ?? Z.main).styles(a), h = n ?? "h1", f = s ?? r;
      return o ? /* @__PURE__ */ e(h, { className: u.name, children: /* @__PURE__ */ e(Pe, { productBase: c, context: "product-card", children: f }) }) : /* @__PURE__ */ e(h, { className: u.name, children: f });
    }
  )
), vn = t.object({
  variants: t.custom().optional()
}), Pn = P(
  "ProductDetailsShortDescription",
  y(vn, ({ variants: a }) => {
    const {
      content: { shortDescription: s }
    } = E(), n = Z.main.styles(a);
    return s ? /* @__PURE__ */ e("p", { className: n.shortDescription, children: s }) : null;
  })
), Ve = t.object({
  variants: t.custom().optional(),
  text: t.string().optional(),
  readMoreSettings: t.object({
    enabled: t.boolean(),
    limit: t.number().optional()
  }).optional(),
  label: t.string().optional(),
  blueprint: t.custom().optional(),
  formatDotsToList: t.boolean().optional()
}), yn = P(
  "ProductDetailsDescription",
  y(
    Ve,
    ({
      variants: a,
      readMoreSettings: s,
      text: n,
      label: o,
      formatDotsToList: i,
      ...c
    }) => {
      const {
        content: { description: r }
      } = E(), u = (c.blueprint ?? Z.main).styles(a), [h, f] = $(!(s != null && s.enabled)), v = I();
      if (!r && !n)
        return null;
      const w = n ?? r, g = w.length > ((s == null ? void 0 : s.limit) ?? 200), b = i ? w.split(`
`).map((S) => {
        const _ = S.trim();
        return _.startsWith("•") ? `<li>${_.substring(1).trim()}</li>` : _ ? `${_}` : "";
      }).join("") : w;
      return /* @__PURE__ */ p("div", { className: u.description, children: [
        o && /* @__PURE__ */ e("h2", { className: u.descriptionLabel, children: o }),
        /* @__PURE__ */ e(
          "p",
          {
            className: h ? "" : "line-clamp-2",
            dangerouslySetInnerHTML: {
              __html: h ? b : `${b.substring(0, 200)}...`
            }
          }
        ),
        (s == null ? void 0 : s.enabled) && g && /* @__PURE__ */ e(
          "button",
          {
            className: u.descriptionReadMoreButton,
            onClick: () => f(!h),
            children: v(h ? "Product_Description_Read_Less" : "Product_Description_Read_More")
          }
        )
      ] });
    }
  )
), Sn = t.object({
  variants: t.custom().optional()
}), wn = P(
  "ProductDetailsBrand",
  y(Sn, ({ variants: a }) => {
    var c;
    const s = E(), n = Z.main.styles(a), i = (c = ee(s)("brandName", t.string())) == null ? void 0 : c.value;
    return i ? /* @__PURE__ */ e("span", { className: n.brand, children: i }) : null;
  })
), mt = t.object({
  drawerSettings: t.custom().optional(),
  trigger: t.custom().optional(),
  isEnabled: t.boolean().optional()
}), _n = 1024, kn = P(
  "PriceHistoryDrawer",
  y(mt, (a) => {
    var h, f;
    const s = qt.styles(), n = ye(), [o, i] = $(!1), c = I(), r = (h = n.previouslyDiscountedPrices) == null ? void 0 : h.find(
      (v) => v.periodDays === 30
    ), l = n.price.formatted !== (r == null ? void 0 : r.price.formatted);
    if (U(() => {
      const v = () => {
        i(window.innerWidth > _n);
      };
      return window.addEventListener("resize", v), v(), () => {
        window.removeEventListener("resize", v);
      };
    }, []), !a.isEnabled)
      return null;
    const u = (f = n.discountInfo) != null && f.percent ? `(-${n.discountInfo.percent}%)` : "";
    return /* @__PURE__ */ p(
      W,
      {
        customOverlayId: "price-history",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        header: {
          headingSettings: {
            heading: c("Price_History_Heading")
          }
        },
        hasHandle: !o,
        variants: {
          dragHandle: o ? "false" : "true",
          rounded: o ? "none" : "strong",
          background: "white",
          direction: o ? "right" : "bottom"
        },
        direction: o ? "right" : "bottom",
        ...a.drawerSettings,
        children: [
          l && /* @__PURE__ */ p(W.Trigger, { className: s.trigger, children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: "absolute w-10 h-10",
                tabIndex: -1,
                "aria-hidden": "true"
              }
            ),
            a.trigger
          ] }),
          /* @__PURE__ */ e(W.Content, { children: /* @__PURE__ */ p("div", { className: s.contentWrapper, children: [
            /* @__PURE__ */ p("div", { className: s.priceRow, children: [
              /* @__PURE__ */ e("span", { className: s.priceValue, children: n.price.formatted }),
              u && /* @__PURE__ */ e("span", { className: s.discountBadge, children: c("Price_History_Current_Price", {
                discountPercent: u
              }) })
            ] }),
            r && /* @__PURE__ */ p("div", { className: s.priceRow, children: [
              /* @__PURE__ */ e("span", { className: s.priceValue, children: r.price.formatted }),
              /* @__PURE__ */ e("span", { className: s.priceLabel, children: c("Price_History_Lowest_Price_In_Last_30_Days") })
            ] }),
            /* @__PURE__ */ p("div", { className: s.priceRow, children: [
              /* @__PURE__ */ e("span", { className: s.priceValue, children: n.priceWithoutDiscount.formatted }),
              /* @__PURE__ */ e("span", { className: s.priceLabel, children: c("Price_History_Original_Price") })
            ] })
          ] }) })
        ]
      }
    );
  })
), ht = t.object({
  variants: t.custom().optional(),
  blueprint: t.custom().optional(),
  priceHistoryDrawerSettings: mt.optional()
}), Nn = P(
  "ProductDetailsPrice",
  y(ht, ({ variants: a, ...s }) => {
    const n = ye(), i = (s.blueprint ?? Z.main).styles(a), c = Q(), r = n.price.number < n.priceWithoutDiscount.number;
    return /* @__PURE__ */ e(X, { children: /* @__PURE__ */ p("div", { className: i.priceWrapper, children: [
      /* @__PURE__ */ e(
        "span",
        {
          "data-is-discounted": r ? "true" : "false",
          className: i.price,
          children: n.price.formatted
        }
      ),
      r && /* @__PURE__ */ p("span", { className: i.oldPrice, children: [
        n.priceWithoutDiscount.formatted,
        /* @__PURE__ */ e(
          m.PriceHistoryDrawer,
          {
            ...s.priceHistoryDrawerSettings
          }
        )
      ] }),
      c === "bundle" && /* @__PURE__ */ e(Tn, {})
    ] }) });
  })
), Tn = () => (Ae(), null), Cn = t.object({
  variants: t.custom().optional(),
  children: t.custom().optional()
}), An = P(
  "ProductDetailsWrapper",
  y(Cn, ({ variants: a, children: s }) => {
    const n = Z.main.styles(a);
    return /* @__PURE__ */ e("section", { className: n.wrapper, children: s });
  })
), pe = t.object({
  variants: t.custom().optional(),
  attributeKey: t.string().optional(),
  className: t.string().optional(),
  label: t.string().optional()
}), Bn = P(
  "ProductDetailsProductType",
  y(
    {
      schema: pe,
      defaultProps: {
        attributeKey: "subHeadline"
      }
    },
    ({ variants: a, attributeKey: s, className: n, label: o }) => {
      var u;
      const i = E(), r = (u = ee(i)(
        s ?? "",
        t.string()
      )) == null ? void 0 : u.value, l = Z.main.styles(a);
      if (!(!r && !o))
        return /* @__PURE__ */ e("span", { className: Ra(l.productType, n), children: o ?? r });
    }
  )
), bt = Ea.extend({
  content: t.object({
    value: t.string().optional(),
    attributeKey: t.string().optional(),
    trigger: t.custom().optional(),
    content: t.custom().optional(),
    forceMount: t.boolean().optional()
  })
}), Dn = t.object({
  variants: t.custom().optional(),
  items: t.array(bt).optional(),
  settings: Ga.omit({ items: !0 }).optional()
}), In = P(
  "ProductDetailsAccordion",
  y(Dn, ({ variants: a, items: s, settings: n }) => {
    const o = E(), i = ee(o), c = Z.main.styles(a), r = s == null ? void 0 : s.map((l) => {
      var h;
      let u = l.content.content;
      if (l.content.attributeKey) {
        const f = (h = i(
          l.content.attributeKey,
          t.string()
        )) == null ? void 0 : h.value;
        if (!u && !f)
          return null;
        u = f ?? u;
      }
      return u ? {
        ...l,
        content: {
          content: u,
          value: l.content.value,
          trigger: l.content.trigger,
          forceMount: l.content.forceMount
        }
      } : null;
    }).filter((l) => l !== null);
    return r ? /* @__PURE__ */ e("div", { className: c.accordionWrapper, children: /* @__PURE__ */ e(
      Wa,
      {
        ...n,
        blueprint: Z.accordion,
        layout: {
          spacing: {
            applySpacing: "false"
          },
          position: {
            applyPosition: "false"
          }
        },
        items: r
      }
    ) }) : null;
  })
), zn = {
  Name: fn,
  ShortDescription: Pn,
  Brand: wn,
  Price: Nn,
  Wrapper: An,
  Description: yn,
  ProductType: Bn,
  Accordion: In
  // Add other components as needed
}, Ln = t.object({
  className: t.string().optional(),
  badgeSettings: st.optional(),
  hide: t.boolean().optional()
}), xn = ({
  badgeSettings: a,
  hide: s,
  className: n
}) => {
  const o = I(), i = Ae(), c = i.discountFromPriceOfItemsOutsideBundle.formatted, r = i.discountFromPriceOfItemsOutsideBundle.number;
  return s || !c || r <= 0 ? null : /* @__PURE__ */ e("div", { className: n, children: /* @__PURE__ */ e(
    He,
    {
      ...a,
      label: o("PDP_Bundle_Savings_Badge", { bundleSavings: c })
    }
  ) });
}, gt = P(
  "BundleSavingsBadge",
  y(Ln, (a) => Q() !== "bundle" ? null : /* @__PURE__ */ e(xn, { ...a }))
), Rn = t.object({
  subHeadlineAttribute: t.string().optional(),
  variants: t.custom().optional()
}), En = P(
  "ShopTheLookItem",
  y(
    {
      schema: Rn,
      defaultProps: {
        subHeadlineAttribute: "subHeadline"
      }
    },
    ({ subHeadlineAttribute: a, variants: s }) => {
      var v;
      const n = E(), o = Da(), i = ye(), c = Q(), r = ee(n), l = Jt.styles(s), u = o == null ? void 0 : o[0], h = i.price.number < i.priceWithoutDiscount.number, f = a ? (v = r(a, t.string())) == null ? void 0 : v.value : void 0;
      return /* @__PURE__ */ p("div", { className: l.wrapper, children: [
        /* @__PURE__ */ p("div", { className: l.contentWrapper, children: [
          u && /* @__PURE__ */ e(
            Pe,
            {
              productBase: n,
              context: "product-card",
              className: l.imageWrapper,
              children: /* @__PURE__ */ e(te, { className: l.image, image: u })
            }
          ),
          /* @__PURE__ */ p("div", { className: l.info, children: [
            /* @__PURE__ */ e("h4", { className: l.productName, children: n.content.name }),
            f && /* @__PURE__ */ e("p", { className: l.productType, children: f }),
            /* @__PURE__ */ p("div", { className: l.priceWrapper, children: [
              /* @__PURE__ */ e(
                "span",
                {
                  "data-is-discounted": h ? "true" : "false",
                  className: l.price,
                  children: i.price.formatted
                }
              ),
              h && /* @__PURE__ */ e("span", { className: l.priceBeforeDiscount, children: i.priceWithoutDiscount.formatted })
            ] })
          ] })
        ] }),
        c === "with_variants" && /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
        /* @__PURE__ */ e(
          m.AddToCart,
          {
            template: "button",
            postAddAction: "none",
            buttonSettings: {
              variants: {
                width: "full"
              }
            }
          }
        )
      ] });
    }
  )
), Ue = "shop_the_look", Gn = t.object({
  media: t.custom().optional(),
  className: t.string().optional(),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional(),
  closeIcon: t.custom().optional(),
  triggerIcon: t.custom().optional(),
  showProductCountAsSuffix: t.boolean().optional()
}), Wn = () => {
  const [a, s] = $(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return U(() => {
    const n = () => {
      s(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, ft = P(
  "ShopTheLook",
  y(
    {
      schema: Gn,
      defaultProps: {}
    },
    ({
      media: a,
      className: s = "",
      variants: n,
      drawerSettings: o,
      closeIcon: i,
      triggerIcon: c,
      showProductCountAsSuffix: r
    }) => {
      const [l, u] = $(!1), h = Wn(), f = Oe(
        a || {
          type: "image",
          src: "",
          alt: ""
        }
      ), v = (a == null ? void 0 : a.type) === "image" && f(Ue, t.boolean()), w = ea.styles(n), g = Be("look"), b = I();
      if (!v || v.value !== !0 || !g.length)
        return null;
      const S = () => {
        Ha.emit("featureInteraction", {
          feature: "shop_the_look",
          action: "clicked"
        });
      };
      return /* @__PURE__ */ p(
        W,
        {
          open: l,
          onOpenChange: u,
          direction: h ? "right" : "bottom",
          variants: {
            rounded: "subtle"
          },
          ...o,
          children: [
            /* @__PURE__ */ e(
              W.Trigger,
              {
                className: s || w.trigger,
                onClick: S,
                "aria-label": `Shop The Look - ${g.length} ${g.length === 1 ? "product" : "products"}`,
                children: /* @__PURE__ */ p("div", { className: w.triggerContent, children: [
                  b("Shop_The_Look_Trigger"),
                  c
                ] })
              }
            ),
            /* @__PURE__ */ p(W.Content, { children: [
              /* @__PURE__ */ e(W.Title, { hidden: !0, children: b("Shop_The_Look_Heading") }),
              /* @__PURE__ */ p("div", { className: w.wrapper, children: [
                /* @__PURE__ */ p("div", { className: w.header, children: [
                  /* @__PURE__ */ e(
                    Va,
                    {
                      heading: b("Shop_The_Look_Heading"),
                      suffix: r ? String(g.length) : void 0,
                      variants: { headingSize: "lg" }
                    }
                  ),
                  /* @__PURE__ */ e(W.Close, { className: w.close, children: i ?? b("Shop_The_Look_Close") })
                ] }),
                /* @__PURE__ */ e("div", { className: w.productList, children: g.map((_, z) => /* @__PURE__ */ e(
                  Ma,
                  {
                    additionalData: {
                      source: "shop-the-look",
                      item_list_id: "shop-the-look",
                      item_list_name: "Shop The Look"
                    },
                    children: /* @__PURE__ */ e(
                      je,
                      {
                        product: _.product,
                        context: {
                          type: "plp",
                          listId: "shop-the-look",
                          listName: "Shop The Look",
                          position: z
                        },
                        children: /* @__PURE__ */ e(En, {})
                      }
                    )
                  },
                  _.product.base.productId
                )) })
              ] })
            ] })
          ]
        }
      );
    }
  )
), vt = {
  mobile: "150vw",
  tablet: "150vw",
  desktop: "100vw"
}, Ze = 60, On = 300, jn = 30, Mn = 10, Kn = 500, Re = (a, s, n) => Math.max(s, Math.min(n, a)), qe = (a, s) => Math.hypot(a.clientX - s.clientX, a.clientY - s.clientY);
function Pt({
  enabled: a = !1,
  maxScale: s = 2.5,
  onZoomChange: n,
  onSwipeAtEdge: o,
  hideCursor: i = !1,
  resetOnMouseLeave: c = !1
} = {}) {
  const [r, l] = R.useState(
    null
  ), u = R.useRef(null), h = R.useRef(null), [f, v] = R.useState(!1), [w, g] = R.useState(!1), [b, S] = R.useState(!1), _ = R.useRef({ onZoomChange: n, onSwipeAtEdge: o });
  _.current = { onZoomChange: n, onSwipeAtEdge: o };
  const z = R.useRef({
    scale: 1,
    tx: 0,
    ty: 0,
    gesture: { type: "idle" },
    rect: null,
    pinchAnchor: null,
    zoomedFlag: !1,
    lastTapAt: 0,
    lastTapX: 0,
    lastTapY: 0,
    lastTouchEndAt: 0,
    tapStartX: 0,
    tapStartY: 0
  }), C = R.useCallback(() => {
    var M, O;
    const d = z.current;
    d.gesture = { type: "idle" }, d.scale = 1, d.tx = 0, d.ty = 0;
    const L = u.current;
    L && (L.style.transition = "transform 250ms", L.style.transform = "translate(0px, 0px) scale(1)"), d.zoomedFlag && (d.zoomedFlag = !1, v(!1), (O = (M = _.current).onZoomChange) == null || O.call(M, !1));
  }, []);
  R.useEffect(() => {
    if (!a || !r)
      return;
    const d = z.current, L = () => {
      d.rect = r.getBoundingClientRect();
    }, M = (k) => {
      const A = u.current;
      A && (d.rect && (d.tx = Re(d.tx, d.rect.width * (1 - d.scale), 0), d.ty = Re(d.ty, d.rect.height * (1 - d.scale), 0)), A.style.transition = k ? "transform 250ms" : "none", A.style.transform = `translate(${d.tx}px, ${d.ty}px) scale(${d.scale})`);
    }, O = (k) => {
      var A, N;
      d.zoomedFlag !== k && (d.zoomedFlag = k, k && g(!0), v(k), (N = (A = _.current).onZoomChange) == null || N.call(A, k));
    }, V = (k, A, N, j) => {
      if (!d.rect)
        return;
      const ne = k - d.rect.left, re = A - d.rect.top;
      d.scale = N, d.tx = -ne * (N - 1), d.ty = -re * (N - 1), M(j);
    }, H = (k, A) => {
      const N = h.current;
      !N || !d.rect || (N.style.transform = `translate(${k - d.rect.left}px, ${A - d.rect.top}px) translate(-50%, -50%)`);
    };
    L();
    const q = (k) => {
      L();
      const A = d.rect;
      if (!A)
        return;
      const N = k.touches[0], j = k.touches[1];
      k.touches.length === 2 && N && j ? (k.preventDefault(), k.stopPropagation(), d.pinchAnchor || (d.pinchAnchor = { scale: d.scale, tx: d.tx, ty: d.ty }), d.gesture = {
        type: "pinch",
        startDist: qe(N, j),
        startScale: d.scale,
        startTx: d.tx,
        startTy: d.ty,
        anchorX: (N.clientX + j.clientX) / 2 - A.left,
        anchorY: (N.clientY + j.clientY) / 2 - A.top
      }) : k.touches.length === 1 && N && d.scale > 1 ? (k.preventDefault(), k.stopPropagation(), d.gesture = {
        type: "pan",
        startX: N.clientX,
        startY: N.clientY,
        startTx: d.tx,
        startTy: d.ty
      }, d.tapStartX = N.clientX, d.tapStartY = N.clientY) : (d.gesture = { type: "idle" }, N && (d.tapStartX = N.clientX, d.tapStartY = N.clientY));
    }, T = (k) => {
      var ne, re, ke, Xe;
      const A = d.gesture;
      if (A.type === "idle")
        return;
      k.preventDefault(), k.stopPropagation();
      const N = k.touches[0], j = k.touches[1];
      if (A.type === "pinch" && N && j && A.startDist > 0) {
        const be = qe(N, j) / A.startDist, Ne = Re(A.startScale * be, 1, s), Te = Ne / A.startScale;
        d.scale = Ne, d.tx = A.anchorX - (A.anchorX - A.startTx) * Te, d.ty = A.anchorY - (A.anchorY - A.startTy) * Te, M(!1);
      } else if (A.type === "pan" && N) {
        const be = A.startTx + (N.clientX - A.startX), Ne = A.startTy + (N.clientY - A.startY);
        if (d.tx = be, d.ty = Ne, M(!1), d.rect && d.scale > 1) {
          const Te = d.rect.width * (1 - d.scale);
          if (be > Ze) {
            (re = (ne = _.current).onSwipeAtEdge) == null || re.call(ne, "prev"), C();
            return;
          }
          if (be < Te - Ze) {
            (Xe = (ke = _.current).onSwipeAtEdge) == null || Xe.call(ke, "next"), C();
            return;
          }
        }
      }
    }, D = (k) => {
      const A = d.gesture;
      if (k.touches.length === 0) {
        if (d.lastTouchEndAt = Date.now(), d.pinchAnchor) {
          const j = d.pinchAnchor;
          d.pinchAnchor = null, d.gesture = { type: "idle" }, d.scale = j.scale, d.tx = j.tx, d.ty = j.ty, M(!0), O(j.scale > 1);
          return;
        }
        const N = k.changedTouches[0];
        if (N && (A.type === "pan" || A.type === "idle") && Math.hypot(
          N.clientX - d.tapStartX,
          N.clientY - d.tapStartY
        ) < Mn) {
          const ne = Date.now(), re = ne - d.lastTapAt, ke = Math.hypot(
            N.clientX - d.lastTapX,
            N.clientY - d.lastTapY
          );
          re < On && ke < jn ? (d.lastTapAt = 0, d.scale > 1 ? C() : (V(N.clientX, N.clientY, s, !0), O(!0))) : (d.lastTapAt = ne, d.lastTapX = N.clientX, d.lastTapY = N.clientY), d.gesture = { type: "idle" };
          return;
        }
        O(d.scale > 1), d.gesture = { type: "idle" };
      } else if (k.touches.length === 1 && A.type === "pinch") {
        const N = k.touches[0];
        d.scale > 1 && N ? d.gesture = {
          type: "pan",
          startX: N.clientX,
          startY: N.clientY,
          startTx: d.tx,
          startTy: d.ty
        } : d.gesture = { type: "idle" };
      }
    }, ae = (k) => {
      Date.now() - d.lastTouchEndAt < Kn || (d.scale > 1 ? C() : (V(k.clientX, k.clientY, s, !0), O(!0)));
    }, he = (k) => {
      H(k.clientX, k.clientY), !(d.scale <= 1) && V(k.clientX, k.clientY, d.scale, !1);
    }, _e = (k) => {
      L(), H(k.clientX, k.clientY), S(!0);
    }, Y = () => {
      S(!1), c && C();
    };
    return r.addEventListener("touchstart", q, {
      passive: !1
    }), r.addEventListener("touchmove", T, { passive: !1 }), r.addEventListener("touchend", D, { passive: !1 }), r.addEventListener("touchcancel", D, { passive: !1 }), r.addEventListener("click", ae), r.addEventListener("mousemove", he), r.addEventListener("mouseenter", _e), r.addEventListener("mouseleave", Y), window.addEventListener("resize", L), window.addEventListener("scroll", L, {
      passive: !0,
      capture: !0
    }), () => {
      r.removeEventListener("touchstart", q), r.removeEventListener("touchmove", T), r.removeEventListener("touchend", D), r.removeEventListener("touchcancel", D), r.removeEventListener("click", ae), r.removeEventListener("mousemove", he), r.removeEventListener("mouseenter", _e), r.removeEventListener("mouseleave", Y), window.removeEventListener("resize", L), window.removeEventListener("scroll", L, { capture: !0 });
    };
  }, [a, r, s, c, C]);
  const x = R.useCallback(
    (d) => {
      a && l(d);
    },
    [a]
  ), B = R.useCallback((d) => {
    u.current = d, d && (d.style.transformOrigin = "0 0", d.style.willChange = "transform", d.style.transform = "translate(0px, 0px) scale(1)");
  }, []), G = R.useCallback((d) => {
    h.current = d;
  }, []);
  return {
    containerRef: x,
    contentRef: B,
    cursorRef: G,
    containerProps: a ? {
      style: {
        touchAction: f ? "none" : "pan-y",
        cursor: i && b ? "none" : void 0
      }
    } : {},
    isZoomed: f,
    hasBeenZoomed: w,
    isHovering: b,
    reset: C
  };
}
const yt = ({
  cursorRef: a,
  Cursor: s,
  isZoomed: n,
  isHovering: o
}) => /* @__PURE__ */ e(
  "div",
  {
    ref: a,
    "aria-hidden": "true",
    className: "absolute left-0 top-0 pointer-events-none will-change-transform",
    children: /* @__PURE__ */ e(s, { isZoomed: n, isHovering: o })
  }
), ze = t.object({
  template: t.literal("keen"),
  variants: t.custom().optional(),
  indicator: t.literal("number").or(t.literal("dots")).optional(),
  navigation: t.object({
    enabled: t.object({
      mobile: t.boolean().optional().default(!1),
      tablet: t.boolean().optional().default(!1),
      desktop: t.boolean().optional().default(!1)
    }),
    prevIcon: t.custom().optional(),
    nextIcon: t.custom().optional()
  }).optional(),
  slidesPerView: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  gap: t.object({
    mobile: t.number().optional(),
    tablet: t.number().optional(),
    desktop: t.number().optional()
  }).optional(),
  children: t.custom().optional(),
  buttonInSlider: t.object({
    enabled: t.boolean().optional(),
    onClick: t.custom().optional(),
    label: t.string().optional()
  }).optional(),
  blueprint: t.custom().optional(),
  videoSettings: ja.optional(),
  customComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Hn = P(
  "ImageGalleryAsKeen",
  y(
    ze,
    ({
      variants: a,
      indicator: s,
      navigation: n,
      slidesPerView: o,
      gap: i,
      children: c,
      buttonInSlider: r,
      videoSettings: l,
      customComponent: u,
      zoom: h,
      zoomCursor: f,
      ...v
    }) => {
      var V, H, q;
      const {
        content: { media: w }
      } = E(), b = (v.blueprint ?? ta).styles(a), [S, _] = R.useState(0);
      function z(T) {
        return (D) => {
          function ae() {
            D.slides.forEach((Y) => {
              Y.classList.remove("active");
            });
          }
          function he(Y) {
            D.slides[Y].classList.add("active");
          }
          function _e() {
            D.slides.forEach((Y, k) => {
              Y.addEventListener("click", () => {
                T.current && T.current.moveToIdx(k);
              });
            });
          }
          D.on("created", () => {
            T.current && (he(D.track.details.rel), _e(), T.current.on("animationStarted", (Y) => {
              ae();
              const k = Y.animator.targetIdx || 0;
              he(Y.track.absToRel(k)), D.moveToIdx(Math.min(D.track.details.maxIdx, k));
            }));
          });
        };
      }
      const C = Je(w, {
        key: nt,
        value: [!1, void 0]
      }), B = (C == null ? void 0 : C.length) === 1, G = R.useMemo(
        () => C.map((T) => T.src).join(","),
        [C]
      ), [F, d] = Qe({
        selector: ".keen-slider__slide",
        mode: "snap",
        loop: !B,
        breakpoints: {
          "(min-width: 0px)": {
            slides: {
              perView: B ? 1 : (o == null ? void 0 : o.mobile) ?? 1,
              spacing: (i == null ? void 0 : i.mobile) ?? 12
            }
          },
          "(min-width: 640px)": {
            slides: {
              perView: B ? 1 : (o == null ? void 0 : o.tablet) ?? 1,
              spacing: (i == null ? void 0 : i.tablet) ?? 24
            }
          },
          "(min-width: 1024px)": {
            slides: {
              perView: B ? 1 : (o == null ? void 0 : o.desktop) ?? 1,
              spacing: (i == null ? void 0 : i.desktop) ?? 20
            }
          }
        },
        slideChanged(T) {
          _(T.track.details.rel);
        }
      });
      R.useEffect(() => {
        _(0);
      }, [G]);
      const [L] = Qe(
        {
          initial: 0,
          slides: {
            perView: "auto",
            spacing: 4
          }
        },
        [z(d)]
      ), M = Oa({
        mobile: (V = n == null ? void 0 : n.enabled) == null ? void 0 : V.mobile,
        tablet: (H = n == null ? void 0 : n.enabled) == null ? void 0 : H.tablet,
        desktop: (q = n == null ? void 0 : n.enabled) == null ? void 0 : q.desktop
      }), O = R.useCallback(
        (T) => {
          const D = d.current;
          D && (T === "next" ? D.next() : D.prev());
        },
        []
      );
      return /* @__PURE__ */ p(
        "div",
        {
          className: b.base,
          "data-button-in-slider": (r == null ? void 0 : r.enabled) ?? !1,
          children: [
            /* @__PURE__ */ e(gt, { className: b.bundleSavingsBadge }),
            /* @__PURE__ */ p(
              "div",
              {
                ref: F,
                className: `keen-slider ${b.galleryWrapper}`,
                children: [
                  c,
                  C.map((T, D) => T ? /* @__PURE__ */ e(
                    Vn,
                    {
                      media: T,
                      position: D,
                      index: D,
                      slots: b,
                      currentSlide: S,
                      videoSettings: l,
                      zoom: h,
                      zoomCursor: f,
                      onSwipeAtEdge: O
                    },
                    `${T.src}-${D}`
                  ) : null),
                  u && u,
                  (r == null ? void 0 : r.enabled) && (r == null ? void 0 : r.onClick) && (r == null ? void 0 : r.label) && /* @__PURE__ */ e(
                    "button",
                    {
                      className: b.linkButton,
                      onClick: r.onClick,
                      children: r.label
                    }
                  ),
                  s === "number" && /* @__PURE__ */ p("span", { className: b.numberIndicator, children: [
                    "[ ",
                    S + 1,
                    " / ",
                    C.length,
                    " ]"
                  ] }),
                  s === "dots" && /* @__PURE__ */ e("span", { className: b.dotsIndicatorWrapper, children: C.map((T, D) => /* @__PURE__ */ e(
                    "button",
                    {
                      "data-is-active": S === D ? "true" : "false",
                      onClick: () => {
                        var ae;
                        return (ae = d.current) == null ? void 0 : ae.moveToIdx(D);
                      },
                      className: b.dotsIndicator
                    },
                    D
                  )) }),
                  !B && (n == null ? void 0 : n.prevIcon) && (n == null ? void 0 : n.nextIcon) && /* @__PURE__ */ p("div", { className: b.arrowsWrapper, ...M, children: [
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.leftArrow,
                        onClick: () => {
                          var T;
                          return (T = d.current) == null ? void 0 : T.prev();
                        },
                        children: n == null ? void 0 : n.prevIcon
                      }
                    ),
                    /* @__PURE__ */ e(
                      "button",
                      {
                        className: b.rightArrow,
                        onClick: () => {
                          var T;
                          return (T = d.current) == null ? void 0 : T.next();
                        },
                        children: n == null ? void 0 : n.nextIcon
                      }
                    )
                  ] })
                ]
              },
              G
            ),
            C.length > 1 && /* @__PURE__ */ e(
              "div",
              {
                ref: L,
                className: `keen-slider thumbnail ${b.thumbnailWrapper}`,
                children: C.map((T, D) => /* @__PURE__ */ e(
                  "div",
                  {
                    "data-is-active": S === D ? "true" : "false",
                    className: `keen-slider__slide relative ${b.thumbnail}`,
                    children: T.type === "image" && /* @__PURE__ */ e(
                      te,
                      {
                        image: { src: T.src, alt: (T == null ? void 0 : T.alt) ?? "dada" },
                        className: "w-full h-full"
                      }
                    )
                  },
                  `${T.src}-${D}`
                ))
              }
            )
          ]
        }
      );
    }
  )
), Vn = ({
  currentSlide: a,
  position: s,
  index: n,
  media: o,
  slots: i,
  videoSettings: c,
  zoom: r,
  zoomCursor: l,
  onSwipeAtEdge: u
}) => {
  const h = a !== n, f = Oe(o), v = o.type === "image" && f("model_is_wearing", t.string()), w = o.type === "image" && f(Ue, t.boolean()), g = !!r && o.type === "image", {
    containerRef: b,
    contentRef: S,
    cursorRef: _,
    containerProps: z,
    isZoomed: C,
    hasBeenZoomed: x,
    isHovering: B,
    reset: G
  } = Pt({
    enabled: g,
    onSwipeAtEdge: u,
    hideCursor: !!l
  });
  if (R.useEffect(() => {
    a !== n && C && G();
  }, [a, n, C, G]), !o)
    return null;
  const F = o.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: o.src, alt: o.alt },
      className: i.image,
      fetchpriority: s < 2 ? "high" : "auto",
      loading: s < 2 ? "eager" : "lazy",
      displaySize: x ? vt : { mobile: "50vw", tablet: "80vw", desktop: "40vw" }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      ref: b,
      ...z,
      "data-is-active": a === n ? "true" : "false",
      className: `keen-slider__slide ${i.imageWrapper} relative`,
      children: [
        o.type !== "image" ? /* @__PURE__ */ e(at, { src: o.src, loop: !0, autoPlay: !0, ...c }) : g ? /* @__PURE__ */ e("div", { ref: S, className: "w-full h-full", children: F }) : F,
        g && l && /* @__PURE__ */ e(
          yt,
          {
            cursorRef: _,
            Cursor: l,
            isZoomed: C,
            isHovering: B
          }
        ),
        v && /* @__PURE__ */ e("div", { className: i.modelIsWearing, children: v.value }),
        w && /* @__PURE__ */ e(ft, { media: o, className: i.shopTheLook }),
        h && /* @__PURE__ */ e("div", { className: i.peekingImage })
      ]
    },
    n
  );
}, St = t.object({
  template: t.literal("grid"),
  variants: t.custom().optional(),
  imageSettings: tt.optional(),
  CustomComponent: t.custom().optional(),
  zoom: t.boolean().optional(),
  zoomCursor: t.custom().optional()
}), Un = P(
  "ImageGalleryAsGrid",
  y(
    St,
    ({ variants: a, imageSettings: s, CustomComponent: n, zoom: o, zoomCursor: i }) => {
      const {
        content: { media: c }
      } = E(), r = aa.styles(a), l = Je(c, {
        key: nt,
        value: [!1, void 0]
      });
      return /* @__PURE__ */ p("div", { className: r.base, children: [
        /* @__PURE__ */ e(gt, { className: r.bundleSavingsBadge }),
        l.map(
          (u, h) => u && /* @__PURE__ */ e(
            $n,
            {
              media: u,
              CustomComponent: n,
              position: h,
              slots: r,
              imageSettings: s,
              amountOfImages: l.length,
              zoom: o,
              zoomCursor: i
            },
            h
          )
        )
      ] });
    }
  )
), $n = ({
  media: a,
  slots: s,
  position: n,
  amountOfImages: o,
  imageSettings: i,
  CustomComponent: c,
  zoom: r,
  zoomCursor: l
}) => {
  const u = Oe(a), h = a.type === "image" && u("model_is_wearing", t.string()), f = a.type === "image" && u(Ue, t.boolean()), v = n === o - 1, w = o % 2 !== 0, g = !!r && a.type === "image", {
    containerRef: b,
    contentRef: S,
    cursorRef: _,
    containerProps: z,
    isZoomed: C,
    hasBeenZoomed: x,
    isHovering: B
  } = Pt({
    enabled: g,
    hideCursor: !!l,
    resetOnMouseLeave: !0
  }), G = a.type === "image" && /* @__PURE__ */ e(
    te,
    {
      image: { src: a.src, alt: a.alt },
      className: s.image,
      fetchpriority: n < 5 ? "high" : "auto",
      loading: n < 5 ? "eager" : "lazy",
      ...i,
      displaySize: x ? vt : (i == null ? void 0 : i.displaySize) ?? {
        mobile: "90vw",
        tablet: "90vw",
        desktop: w && v ? "60vw" : "25vw"
      }
    }
  );
  return /* @__PURE__ */ p(
    "div",
    {
      className: s.imageWrapper,
      "data-has-shop-the-look": f ? "true" : "false",
      "data-has-model-is-wearing": h ? "true" : "false",
      "data-position": n,
      children: [
        g ? /* @__PURE__ */ p(
          "div",
          {
            ref: b,
            ...z,
            className: "absolute inset-0 overflow-hidden",
            children: [
              /* @__PURE__ */ e("div", { ref: S, className: "w-full h-full", children: G }),
              l && /* @__PURE__ */ e(
                yt,
                {
                  cursorRef: _,
                  Cursor: l,
                  isZoomed: C,
                  isHovering: B
                }
              )
            ]
          }
        ) : a.type === "image" ? G : /* @__PURE__ */ e(at, { src: a.src, loop: !0, autoPlay: !0 }),
        h && /* @__PURE__ */ e("div", { className: s.modelIsWearing, children: h.value }),
        f && /* @__PURE__ */ e(ft, { media: a, className: s.shopTheLook }),
        c && /* @__PURE__ */ e(c, { position: n, amountOfImages: o })
      ]
    }
  );
}, wt = t.discriminatedUnion("template", [
  ze,
  St
]), Fn = P(
  "ImageGallery",
  y(wt, (a) => a.template === "keen" ? /* @__PURE__ */ e(Hn, { ...a }) : a.template === "grid" ? /* @__PURE__ */ e(Un, { ...a }) : null)
), _t = t.object({
  template: t.literal("table"),
  variants: t.custom().optional(),
  groupId: t.string().optional(),
  content: t.object({
    heading: t.string().optional(),
    headingTag: t.union([
      t.literal("h1"),
      t.literal("h2"),
      t.literal("h3"),
      t.literal("h4"),
      t.literal("h5"),
      t.literal("h6")
    ]).optional()
  }).optional()
}), Yn = P(
  "ProductSpecificationsAsTable",
  y(
    {
      schema: _t,
      defaultProps: {
        template: "table",
        groupId: "pdp_specifications"
      }
    },
    ({ variants: a, content: s, groupId: n }) => {
      const o = na.styles(a), i = (s == null ? void 0 : s.headingTag) || "h3", c = Ia(
        n ?? "pdp_specifications"
      );
      return !c || !c.length ? null : /* @__PURE__ */ p("div", { className: o.base, children: [
        (s == null ? void 0 : s.heading) && /* @__PURE__ */ e(i, { className: o.heading, children: s.heading }),
        /* @__PURE__ */ e("ol", { className: o.tableWrapper, children: c.map((r, l) => /* @__PURE__ */ p("li", { className: o.row, children: [
          /* @__PURE__ */ p("span", { className: o.label, children: [
            (r == null ? void 0 : r.icon) && /* @__PURE__ */ e("span", { className: o.icon, children: r.icon }),
            r.label
          ] }),
          /* @__PURE__ */ e("span", { className: o.value, children: r.value })
        ] }, l)) })
      ] });
    }
  )
), kt = t.discriminatedUnion("template", [
  _t
]), Xn = P(
  "ProductSpecifications",
  y(kt, (a) => a.template === "table" ? /* @__PURE__ */ e(Yn, { ...a }) : null)
), Qn = t.object({
  label: t.string(),
  barColor: t.string().optional(),
  /**
   * The key for the attribute.
   * @type {string}
   */
  attributeKey: t.string()
}), $e = t.object({
  template: t.literal("progress-bar"),
  variants: t.custom().optional(),
  features: t.object({
    /** On a scale of. @default 10 */
    onAScaleOf: t.number()
  }).optional(),
  items: Qn.array().optional()
}), Zn = P(
  "AttributesAsProgressBar",
  y(
    $e,
    ({
      variants: a,
      features: s = {
        onAScaleOf: 10
      },
      items: n
    }) => {
      const o = sa.styles(a), i = E(), c = ee(i);
      if (!n)
        return null;
      const r = n.map((l) => {
        var h;
        const u = (h = c(l.attributeKey, t.string())) == null ? void 0 : h.value;
        if (u)
          return {
            label: l.label,
            score: parseInt(u),
            barColor: l.barColor
          };
      }).filter(Ua);
      return r.length === 0 ? null : /* @__PURE__ */ e("div", { className: o.base, children: r.map((l, u) => /* @__PURE__ */ p("div", { className: o.item, children: [
        /* @__PURE__ */ e("div", { className: o.label, children: l.label }),
        /* @__PURE__ */ e("div", { className: o.bar, children: /* @__PURE__ */ e(
          J.div,
          {
            className: o.barFill,
            initial: { width: 0 },
            whileInView: {
              width: `${l.score / s.onAScaleOf * 100}%`
            },
            exit: { width: 0 },
            transition: { delay: u * 0.16 },
            style: {
              backgroundColor: l.barColor
            }
          }
        ) }),
        /* @__PURE__ */ p("div", { className: o.scoreLabel, children: [
          l.score,
          "/",
          s.onAScaleOf
        ] })
      ] }, u)) });
    }
  )
), Qo = t.string(), Fe = t.object({
  template: t.literal("tags"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional()
}), qn = P(
  "AttributesAsTags",
  y(Fe, ({ variants: a, attributeKey: s, label: n }) => {
    const o = oa.styles(a), i = K(
      s,
      t.union([
        t.string(),
        t.array(t.string()),
        t.array(t.object({ description: t.string() }))
      ])
    );
    if (!i)
      return null;
    const c = Array.isArray(i.value) ? i.value : [i.value];
    return c.length ? /* @__PURE__ */ p("div", { className: o.base, children: [
      n && /* @__PURE__ */ e("span", { className: o.label, children: n }),
      /* @__PURE__ */ e("div", { className: o.tags, children: c.map((r, l) => /* @__PURE__ */ e("div", { className: o.tag, children: typeof r == "object" ? r.description : r }, `${r}-${l}`)) })
    ] }) : null;
  })
), Nt = t.object({
  template: t.literal("icon-blocks"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string(),
  label: t.string().optional(),
  features: t.object({}).optional(),
  link: $a.optional()
}), Jn = P(
  "AttributesAsIconBlocks",
  y(
    Nt,
    ({ variants: a, attributeKey: s, label: n, link: o }) => {
      var r, l;
      const i = ia.styles(a), c = (r = K(
        s,
        t.array(
          t.object({
            description: t.string().optional(),
            image: t.object({
              url: t.string()
            }).optional()
          })
        )
      )) == null ? void 0 : r.value;
      if (c)
        return /* @__PURE__ */ p("div", { className: i.base, children: [
          /* @__PURE__ */ p("div", { className: i.header, children: [
            n && /* @__PURE__ */ e("span", { className: i.label, children: n }),
            ((l = o == null ? void 0 : o.link) == null ? void 0 : l.href) && /* @__PURE__ */ e(Fa, { as: "a", className: i.link, ...o })
          ] }),
          /* @__PURE__ */ e("div", { className: i.blocks, children: c.map(
            (u, h) => {
              var f;
              return (f = u.image) != null && f.url ? /* @__PURE__ */ p(
                "div",
                {
                  className: i.block,
                  children: [
                    /* @__PURE__ */ e(
                      te,
                      {
                        className: i.icon,
                        image: {
                          src: u.image.url,
                          alt: u.description
                        }
                      }
                    ),
                    /* @__PURE__ */ e("span", { className: i.description, children: u.description })
                  ]
                },
                `${u.description}-${h}`
              ) : null;
            }
          ) })
        ] });
    }
  )
), Tt = t.object({
  template: t.literal("row"),
  variants: t.custom().optional(),
  /**
   * The key for the attribute on the product.
   */
  attributeKey: t.string().optional(),
  data: t.object({
    attributeLabel: t.string().optional(),
    value: t.string().optional().or(t.custom().optional())
  }).optional()
}), es = P(
  "AttributesAsRow",
  y(Tt, ({ variants: a, attributeKey: s, data: n }) => {
    const o = ra.styles(a), i = I(), c = K(s || "", t.string()), { attributeLabel: r, value: l } = c || n || {};
    return !c && !n ? null : /* @__PURE__ */ p("div", { className: o.base, children: [
      r && /* @__PURE__ */ e("label", { className: o.label, children: i(r) }),
      /* @__PURE__ */ e("h4", { className: o.value, children: l })
    ] });
  })
), ts = t.discriminatedUnion("template", [
  $e,
  Fe,
  Nt,
  Tt
]), as = P(
  "ProductAttributes",
  y(ts, (a) => a.template === "progress-bar" ? /* @__PURE__ */ e(Zn, { ...a }) : a.template === "tags" ? /* @__PURE__ */ e(qn, { ...a }) : a.template === "icon-blocks" ? /* @__PURE__ */ e(Jn, { ...a }) : a.template === "row" ? /* @__PURE__ */ e(es, { ...a }) : null)
), ns = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("path", { d: "M0,5h12v2H0v-2Z" })
    ]
  }
), ss = ({ className: a }) => /* @__PURE__ */ p(
  "svg",
  {
    className: a,
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    version: "1.1",
    viewBox: "0 0 12 12",
    children: [
      /* @__PURE__ */ e("defs", {}),
      /* @__PURE__ */ e("polygon", { points: "12 5 7 5 7 0 5 0 5 5 0 5 0 7 5 7 5 12 7 12 7 7 12 7 12 5" })
    ]
  }
), os = t.object({
  setDisplayGoToCheckoutButton: t.custom(),
  amount: t.number(),
  slots: t.custom(),
  increaseButtonSettings: ue.optional(),
  decreaseButtonSettings: ue.optional()
}), is = P(
  "AddToCartQuanityPickerRow",
  y(
    os,
    ({
      setDisplayGoToCheckoutButton: a,
      slots: s,
      amount: n,
      decreaseButtonSettings: o,
      increaseButtonSettings: i
    }) => {
      const {
        addToCartMethod: c,
        removeFromCartMethod: r,
        quantityInCart: l,
        isAvailable: u
      } = Ie(), h = I();
      function f(v) {
        c.execute(v), a(!0);
      }
      return /* @__PURE__ */ p("div", { className: s.quantityPickerWrapper, children: [
        /* @__PURE__ */ e(
          fe,
          {
            ...o,
            disabled: l < n,
            progress: r.loadingState,
            onClick: () => r.execute(n)
          }
        ),
        /* @__PURE__ */ p("div", { className: s.quantityDisplay, children: [
          /* @__PURE__ */ e("span", { className: s.quantityText, children: n }),
          /* @__PURE__ */ e("span", { className: s.quantityUnit, children: h("PDP_Quantity_Picker_Suffix") })
        ] }),
        /* @__PURE__ */ e(
          fe,
          {
            ...i,
            progress: c.loadingState,
            disabled: !u,
            onClick: () => f(n)
          }
        )
      ] });
    }
  )
), Ct = t.object({
  template: t.literal("quantity-picker"),
  variants: t.custom().optional(),
  features: t.object({
    increaseButtonSettings: ue.optional(),
    decreaseButtonSettings: ue.optional(),
    itemSuffix: t.string().optional(),
    /** An optional boolean that determines whether the price should be displayed. @default true */
    showPrice: t.boolean().optional(),
    /** An optional array of numbers that defines the quantity options for adding items to the cart @default [1, 10] */
    addQuantityOptions: t.array(t.number()).optional(),
    postAddAction: t.union([t.literal("goToCheckoutButton"), t.literal("none")]).optional()
  }).optional()
}), rs = P(
  "AddToCartQuantityPicker",
  y(
    {
      schema: Ct,
      defaultProps: {
        template: "quantity-picker",
        features: {
          showPrice: !0,
          addQuantityOptions: [1, 10],
          postAddAction: "goToCheckoutButton",
          increaseButtonSettings: {
            variants: {
              width: "auto",
              size: "md",
              color: "primary"
            },
            iconRight: /* @__PURE__ */ e(ss, { className: "w-3 h-3" }),
            label: "Add"
          },
          decreaseButtonSettings: {
            variants: {
              width: "same-as-height",
              size: "md",
              color: "white"
            },
            iconLeft: /* @__PURE__ */ e(ns, { className: "w-3 h-3" })
          }
        }
      }
    },
    ({ variants: a, features: s }) => {
      var b;
      const n = ye(), o = la.styles(a), [i, c] = $(!1), r = I(), [l, u] = $(0);
      Ee(null);
      const {
        addToCartMethod: h,
        removeFromCartMethod: f,
        quantityInCart: v,
        isAvailable: w
      } = Ie(), g = () => {
        l && (l > v ? (h.execute(l - v), c(!0)) : l < v && f.execute(v - l));
      };
      return U(() => {
        u(0);
      }, [v]), /* @__PURE__ */ p("div", { className: o.base, children: [
        /* @__PURE__ */ p("div", { className: o.innerWrapper, children: [
          (s == null ? void 0 : s.showPrice) && /* @__PURE__ */ p(X, { children: [
            /* @__PURE__ */ e(
              "span",
              {
                className: o.priceTag,
                "data-is-discounted": n.discountInfo ? "true" : "false",
                children: n.price.formatted
              }
            ),
            n.discountInfo && /* @__PURE__ */ e("span", { className: o.oldPriceTag, children: n.priceWithoutDiscount.formatted })
          ] }),
          /* @__PURE__ */ e("div", { className: o.currentQuantityWrapper, children: /* @__PURE__ */ p("div", { className: o.currentQuantityInputWrapper, children: [
            /* @__PURE__ */ e(
              "form",
              {
                onSubmit: (S) => {
                  S.preventDefault(), g();
                },
                children: /* @__PURE__ */ e(
                  "input",
                  {
                    onChange: (S) => {
                      S.preventDefault(), u(parseInt(S.target.value));
                    },
                    value: l > 0 ? l : "",
                    className: o.currentQuantityInput,
                    placeholder: v.toString(),
                    min: "0",
                    type: "number",
                    enterKeyHint: "done",
                    autoComplete: "off",
                    autoCorrect: "off",
                    spellCheck: "false"
                  }
                )
              }
            ),
            l > 0 ? /* @__PURE__ */ e(
              fe,
              {
                disabled: !w,
                onClick: g,
                className: o.updateButton,
                progress: l > v ? h.loadingState : f.loadingState,
                variants: {
                  size: "md",
                  width: "same-as-height"
                },
                label: r("PDP_Quantity_Picker_Update")
              }
            ) : /* @__PURE__ */ e("span", { className: o.currentQuantityUnit, children: r("PDP_Quantity_Picker_Suffix") })
          ] }) }),
          /* @__PURE__ */ e("div", { className: o.quantityPickersWrapper, children: (b = s == null ? void 0 : s.addQuantityOptions) == null ? void 0 : b.map((S, _) => /* @__PURE__ */ e(
            is,
            {
              increaseButtonSettings: s.increaseButtonSettings,
              decreaseButtonSettings: s.decreaseButtonSettings,
              amount: S,
              slots: o,
              setDisplayGoToCheckoutButton: c
            },
            _
          )) })
        ] }),
        /* @__PURE__ */ e(de, { children: i && /* @__PURE__ */ e(
          J.div,
          {
            initial: { marginTop: -50 },
            animate: { marginTop: 0 },
            transition: {
              type: "spring",
              stiffness: 300,
              damping: 15,
              mass: 0.5
            },
            children: /* @__PURE__ */ e(
              se,
              {
                as: "a",
                variants: {
                  width: "full",
                  style: "solid",
                  color: "black"
                },
                label: r("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), At = {
  available: "PDP_Add_To_Cart",
  "out-of-stock": "PDP_Out_Of_Stock",
  discontinued: "PDP_Discontinued",
  "not-determined": "PDP_Select_Size"
}, ls = (a) => {
  const s = De(), n = I(), o = s.status === "out-of-stock" && a ? n("Notify_Me_Submit_Label") : n(At[s.status]) ?? "PDP_Select_Size";
  return n(o);
}, Bt = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  animateAddToCartLabel: t.boolean().optional(),
  postAddAction: t.union([
    t.literal("goToCheckoutButton"),
    t.literal("showMinicart"),
    t.literal("none")
  ]).optional(),
  isNotifyMeEnabled: t.boolean().optional()
}), cs = P(
  "AddToCartButton",
  y(
    {
      schema: Bt,
      defaultProps: {
        template: "button",
        animateAddToCartLabel: !0,
        postAddAction: "showMinicart",
        isNotifyMeEnabled: !1
      }
    },
    ({
      variants: a,
      buttonSettings: s,
      animateAddToCartLabel: n,
      postAddAction: o,
      isNotifyMeEnabled: i
    }) => {
      const c = ca.styles(a), { addToCartMethod: r, isAvailable: l, isOutOfStock: u, isDiscontinued: h } = Ie(), f = u && i, v = ls(f), w = I(), g = typeof window < "u" && window.location.pathname.includes("/checkout"), [b, S] = $(!1), _ = Ge(async () => {
        if (!h) {
          if (u && i) {
            ce.emit("open", { overlayId: "notify-me" });
            return;
          } else if (!l) {
            qa.error(w("Add_To_Cart_Error_Not_Available_Toast"));
            return;
          }
          await r.execute(), o === "goToCheckoutButton" && S(!0), o === "showMinicart" && !g && ce.emit("open", { overlayId: "mini-cart" });
        }
      }, [
        u,
        i,
        r,
        o,
        w,
        g
      ]), z = Xt(
        () => n ? /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e(
          J.span,
          {
            exit: {
              y: "-190%",
              opacity: 0.7,
              transition: {
                duration: 0.15
              }
            },
            initial: {
              y: "150%",
              opacity: 0.7
            },
            animate: {
              y: 0,
              opacity: 1,
              transition: {
                duration: 0.15
              }
            },
            children: v
          },
          v
        ) }) : v,
        [n, v]
      );
      return /* @__PURE__ */ p("div", { className: c.base, id: "add-to-cart-component", children: [
        /* @__PURE__ */ e(
          se,
          {
            as: "button",
            variants: {
              width: "full"
            },
            ...s,
            progress: r.loadingState,
            dataAttr: {
              "appear-disabled": (u || h) && !f
            },
            "aria-disabled": !l && !f ? "true" : "false",
            label: z,
            onClick: _
          }
        ),
        /* @__PURE__ */ e(de, { initial: !1, children: b && /* @__PURE__ */ e(
          J.div,
          {
            initial: { y: "-100%" },
            animate: { y: 0 },
            transition: {
              duration: 0.5,
              ease: ot(0.32, 0.72, 0, 1)
            },
            children: /* @__PURE__ */ e(
              se,
              {
                as: "a",
                variants: {
                  width: "full",
                  color: "black",
                  style: "outline"
                },
                label: w("PDP_Go_To_Checkout"),
                link: { href: "checkout" }
              }
            )
          }
        ) })
      ] });
    }
  )
), Dt = t.discriminatedUnion("template", [
  Ct,
  Bt
]), ds = P(
  "ProductAddToCart",
  y(Dt, (a) => Q() === "bundle" ? null : a.template === "button" ? /* @__PURE__ */ e(cs, { ...a }) : a.template === "quantity-picker" ? /* @__PURE__ */ e(rs, { ...a }) : null)
), Se = t.object({
  template: t.literal("button-grid"),
  variants: t.custom().optional(),
  notifyMe: t.object({
    enabled: t.boolean().optional(),
    icon: t.custom().optional()
  }).optional(),
  lowStockIndicator: t.object({
    /**
     * Enables/disables the low stock indicator functionality
     * @default false
     */
    enabled: t.boolean().optional(),
    /**
     * Display a component to indicate low stock
     */
    headerContent: t.custom().optional(),
    /**
     * Threshold value below which stock is considered low
     * Triggers visual indicator when stock drops below this number
     * @default 5
     */
    lowStockLimit: t.number().optional()
  }).optional(),
  headerContent: t.custom().optional()
}), us = P(
  "SizePickerButtonGrid",
  y(
    Se,
    ({ variants: a, notifyMe: s, lowStockIndicator: n, headerContent: o }) => {
      var g;
      const i = da.styles(a), { optionGroups: c, selectOption: r, selectedOptions: l } = Me(), u = I(), h = c.length === 1 && ((g = c[0]) == null ? void 0 : g.options.length) === 1;
      if (h)
        return null;
      U(() => {
        var b;
        h && ((b = c[0]) != null && b.options[0]) && r(
          c[0].dimensionKey,
          c[0].options[0]
        );
      }, []);
      const f = (n == null ? void 0 : n.lowStockLimit) ?? 5, v = (b) => (n == null ? void 0 : n.enabled) === !0 && b.inventory.inStock && b.inventory.quantity < f, w = c.some(
        (b) => b.options.some(v)
      );
      return /* @__PURE__ */ p("div", { className: i.base, children: [
        /* @__PURE__ */ p("div", { className: i.header, children: [
          /* @__PURE__ */ e("span", { children: u("PDP_Size_Picker_Select_Size") }),
          w ? n == null ? void 0 : n.headerContent : o
        ] }),
        c.map((b) => /* @__PURE__ */ e("div", { className: i.wrapper, children: b.options.map((S) => {
          var B;
          const _ = ((B = l[b.dimensionKey]) == null ? void 0 : B.dimensionValue) === S.dimensionValue, z = S.inventory.inStock, C = v(S), x = () => {
            r(b.dimensionKey, S);
          };
          return /* @__PURE__ */ p(
            "button",
            {
              type: "button",
              "data-is-selected": _ ? "true" : "false",
              "data-is-out-of-stock": z ? "false" : "true",
              disabled: !z && !(s != null && s.enabled),
              className: i.size,
              "aria-label": S.label,
              onClick: x,
              children: [
                C && (n == null ? void 0 : n.enabled) && /* @__PURE__ */ e("span", { className: i.lowStockIndicator }),
                (s == null ? void 0 : s.enabled) && !z && s.icon,
                S.label
              ]
            },
            S.dimensionValue
          );
        }) }, b.dimensionKey))
      ] });
    }
  )
), ps = {
  direction: "right",
  variants: {
    rounded: "none"
  }
}, ms = {
  style: "outline",
  width: "full"
}, ve = t.object({
  template: t.literal("modal"),
  variants: t.custom().optional(),
  drawerSettings: t.custom().optional().describe("Settings for the drawer"),
  buttonVariants: t.custom().optional().describe("Variants for the button"),
  triggerLabel: t.string().optional(),
  sizeButtons: We.optional(),
  aboveButtonComponent: t.custom().optional(),
  belowButtonComponent: t.custom().optional(),
  customOverlayId: t.string().optional()
}), hs = () => {
  const [a, s] = $(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return U(() => {
    const n = () => {
      s(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), a;
}, bs = P(
  "SizePickerModal",
  y(
    {
      schema: ve,
      defaultProps: {
        template: "modal",
        drawerSettings: ps,
        buttonVariants: ms,
        sizeButtons: {
          variants: {
            rounded: "full",
            width: "same-as-height",
            size: "md",
            color: "black",
            style: "outline"
          }
        },
        customOverlayId: "size-picker-modal"
      }
    },
    ({
      variants: a,
      drawerSettings: s,
      buttonVariants: n,
      triggerLabel: o,
      sizeButtons: i,
      aboveButtonComponent: c,
      belowButtonComponent: r,
      customOverlayId: l
    }) => {
      const u = I(), h = hs(), f = ua.styles(a), { optionGroups: v, selectOption: w, selectedOptions: g } = Me();
      return /* @__PURE__ */ p(
        W,
        {
          hasOverlay: !0,
          ...s,
          variants: {
            direction: h ? "right" : "bottom",
            ...(s ?? {}).variants
          },
          customOverlayId: l ?? "size-picker-modal",
          direction: h ? "right" : "bottom",
          children: [
            /* @__PURE__ */ e(W.Trigger, { className: f.trigger, children: /* @__PURE__ */ e(
              it,
              {
                label: o ?? u("Size_Picker_Select_Size"),
                variants: n
              }
            ) }),
            /* @__PURE__ */ p(W.Content, { children: [
              /* @__PURE__ */ e("div", { className: f.optionsWrapper, children: v.map((b) => /* @__PURE__ */ p(
                "div",
                {
                  className: f.wrapper,
                  "data-dimension-key": b.dimensionKey,
                  "data-dimension-label": b.dimensionLabel,
                  children: [
                    /* @__PURE__ */ e("div", { className: f.header, children: /* @__PURE__ */ e("h3", { className: f.heading, children: u(`Size_Picker_${b.dimensionLabel}`) }) }),
                    /* @__PURE__ */ e("div", { className: f.sizeWrapper, children: b.options.map((S, _) => {
                      var C;
                      const z = ((C = g[b.dimensionKey]) == null ? void 0 : C.dimensionValue) === S.dimensionValue;
                      return /* @__PURE__ */ e(
                        fe,
                        {
                          dataAttr: {
                            "is-selected": z,
                            "is-out-of-stock": !S.inventory.inStock
                          },
                          className: f.size,
                          onClick: () => w(b.dimensionKey, S),
                          label: S.label,
                          ...i
                        },
                        `${S.label}-${_}`
                      );
                    }) })
                  ]
                },
                b.dimensionKey
              )) }),
              c,
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              r
            ] })
          ]
        }
      );
    }
  )
), gs = t.discriminatedUnion("template", [
  Se,
  ve
]), fs = P(
  "ProductSizePicker",
  y(gs, (a) => Q() !== "with_variants" ? null : a.template === "button-grid" ? /* @__PURE__ */ e(us, { ...a }) : a.template === "modal" ? /* @__PURE__ */ e(bs, { ...a }) : null)
), Ye = t.object({
  template: t.literal("image-card"),
  colorAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  headingTag: t.enum(["h1", "h2", "h3", "h4", "h5", "h6"]).optional(),
  hide: t.boolean().optional()
}), vs = P(
  "SiblingsImageCard",
  y(
    {
      schema: Ye,
      defaultProps: {
        template: "image-card",
        colorAttributeKey: "product_color",
        headingTag: "h2"
      }
    },
    ({ variants: a, colorAttributeKey: s, headingTag: n }) => {
      const o = I(), i = pa.styles(a), c = K(
        s ?? "",
        t.string()
      ), r = E(), l = et(), u = n ?? "h2";
      return l.length ? /* @__PURE__ */ p("div", { className: i.base, children: [
        c && /* @__PURE__ */ e(u, { className: i.header, children: o("PDP_Siblings_Header_Title", {
          color: c.value,
          colorName: c.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: i.siblingsWrapper, children: l.map((h, f) => {
          var v, w, g, b, S, _;
          return (g = (w = (v = h.content) == null ? void 0 : v.media) == null ? void 0 : w[0]) != null && g.src ? /* @__PURE__ */ e(
            Pe,
            {
              productBase: h,
              context: "product-sibling",
              className: i.sibling,
              "data-is-selected": h.productId === r.productId,
              children: /* @__PURE__ */ e(
                te,
                {
                  image: { src: (_ = (S = (b = h.content) == null ? void 0 : b.media) == null ? void 0 : S[0]) == null ? void 0 : _.src },
                  displaySize: {
                    mobile: "80px",
                    tablet: "80px",
                    desktop: "80px"
                  },
                  className: i.siblingImage
                }
              )
            },
            f
          ) : null;
        }) })
      ] }) : null;
    }
  )
), Ps = (a) => /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(a), ys = (a) => /^[a-zA-Z]+$/.test(a) || /^[a-zA-Z]+\s[a-zA-Z]+$/.test(a), Ss = (a) => /^rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)$/.test(a) || /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*[\d.]+\s*\)$/.test(a), ws = (a) => a.startsWith("http") || a.startsWith("/") || /\.(png|jpe?g|gif|svg|webp)$/i.test(a), It = ({
  sibling: a,
  colorSwatchAttributeKey: s,
  className: n
}) => {
  const o = E(), i = ee(a);
  if (!s)
    return null;
  const c = i(
    s,
    t.string()
  );
  if (!(c != null && c.valueLabel))
    return null;
  const r = c.valueLabel, l = c.value, u = () => l ? ws(l) ? {
    backgroundImage: `url(${l})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat"
  } : Ps(l) || ys(l) || Ss(l) ? { backgroundColor: l } : { backgroundColor: "#cccccc" } : {}, h = `${r || ""} color option`;
  return /* @__PURE__ */ e(
    Pe,
    {
      productBase: a,
      context: "product-sibling",
      className: n,
      style: u(),
      "data-is-selected": o.productId === a.productId,
      "data-is-white": l === "#ffffff" || (r == null ? void 0 : r.toLocaleLowerCase()) === "white" || (r == null ? void 0 : r.toLocaleLowerCase()) === "vit",
      "aria-label": h,
      title: r || "",
      role: "button",
      "data-testid": `color-swatch-${r == null ? void 0 : r.toLowerCase().replace(/\s+/g, "-")}`
    },
    a.productKey
  );
}, zt = t.object({
  template: t.literal("color-swatch"),
  colorSwatchAttributeKey: t.string().optional(),
  variants: t.custom().optional(),
  hide: t.boolean().optional()
}), _s = P(
  "SiblingColorSwatchList",
  y(
    {
      schema: zt,
      defaultProps: {
        template: "color-swatch",
        colorSwatchAttributeKey: "product_color"
      }
    },
    ({ variants: a, colorSwatchAttributeKey: s }) => {
      const n = ma.styles(a), o = E(), i = I(), c = et(), r = ee(o);
      if (!s || !c.length)
        return null;
      const l = r(
        s,
        t.string()
      );
      return l ? /* @__PURE__ */ p("div", { className: n.base, children: [
        /* @__PURE__ */ e("div", { className: n.header, children: i("PDP_Product_ColorSwatch_Label", {
          color: l.valueLabel
        }) }),
        /* @__PURE__ */ e("div", { className: n.siblingsWrapper, children: c.map((u, h) => /* @__PURE__ */ e(
          It,
          {
            sibling: u,
            colorSwatchAttributeKey: s,
            className: n.sibling
          },
          `sibling.productKey-${h}`
        )) })
      ] }) : null;
    }
  )
), we = t.discriminatedUnion("template", [
  Ye,
  zt
]), ks = P(
  "ProductSiblings",
  y(we, (a) => a.hide === !0 ? null : a.template === "image-card" ? /* @__PURE__ */ e(vs, { ...a }) : a.template === "color-swatch" ? /* @__PURE__ */ e(_s, { ...a }) : null)
), Lt = t.object({
  template: t.literal("image-cards"),
  swiperSettings: lt.optional(),
  relationType: t.string().optional(),
  productCardSettings: Ja.optional()
}), Ns = (a) => {
  const s = tn(), n = I();
  if (!s || s.length === 0)
    return null;
  const o = ha.styles();
  return /* @__PURE__ */ p("div", { className: o.base, children: [
    /* @__PURE__ */ e("h3", { className: o.heading, children: n("PDP_Related_Products_Image_Cards_Heading") }),
    /* @__PURE__ */ e("div", { className: o.wrapper, children: s.slice(0, 3).map((i, c) => i.type !== "product" ? null : /* @__PURE__ */ e(
      je,
      {
        product: i.product,
        context: {
          type: "plp",
          listId: "related-products",
          listName: "Related Products",
          position: c
        },
        children: /* @__PURE__ */ e(en, { templateProps: a.productCardSettings })
      },
      c
    )) })
  ] });
}, xt = P(
  "ProductRelatedProductsImageCards",
  y(Lt, ({ relationType: a, ...s }) => {
    const n = Be(a);
    if (!xt.length)
      return null;
    const o = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      facets: [],
      sort: []
    };
    return /* @__PURE__ */ e(rt, { result: o, children: /* @__PURE__ */ e(Ns, { ...s }) });
  })
), Rt = t.object({
  template: t.literal("swiper"),
  swiperSettings: lt.optional(),
  relationType: t.string().optional()
}), Ts = P(
  "ProductRelatedProductsSwiper",
  y(Rt, ({ swiperSettings: a, relationType: s }) => {
    const n = Be(s);
    if (!n.length)
      return null;
    const o = {
      items: n.map((i) => ({ type: "product", product: i.product })),
      meta: {
        currentPage: 1,
        totalPages: 5,
        itemsPerPage: 12,
        totalItems: n.length
      },
      sort: [],
      facets: []
    };
    return /* @__PURE__ */ e(rt, { result: o, children: /* @__PURE__ */ e(an, { ...a }) });
  })
), ie = t.discriminatedUnion("template", [
  Lt,
  Rt
]), Cs = P(
  "RelatedProducts",
  y(ie, (a) => a.template === "image-cards" ? /* @__PURE__ */ e(xt, { ...a }) : a.template === "swiper" ? /* @__PURE__ */ e(Ts, { ...a }) : null)
), As = ({
  targetSelector: a,
  mode: s = "isNotVisible"
}) => {
  const [n, o] = $(!1), i = Ee(null), c = Ee(null);
  U(() => {
    if (s === "isAlwaysVisible") {
      o(!0);
      return;
    } else if (s === "isAlwaysHidden") {
      o(!1);
      return;
    }
  }, [s]);
  const r = Ge(() => {
    if (!i.current)
      return;
    const u = i.current.getBoundingClientRect();
    switch (s) {
      case "isScrolledPast":
        o(u.bottom <= 0);
        break;
      case "isBeforeView":
        o(u.top >= window.innerHeight);
        break;
    }
  }, [s]), l = Ge(() => {
    c.current && cancelAnimationFrame(c.current), c.current = requestAnimationFrame(() => {
      r(), c.current = null;
    });
  }, [r]);
  return U(() => {
    if (s === "isAlwaysVisible" || s === "isAlwaysHidden" || (i.current = document.querySelector(a), !i.current))
      return;
    let u = null;
    return s === "isVisible" || s === "isNotVisible" ? (u = new IntersectionObserver(
      ([h]) => {
        h && o(
          s === "isVisible" ? h.isIntersecting : !h.isIntersecting
        );
      },
      { threshold: 0.1 }
    ), u.observe(i.current)) : (r(), window.addEventListener("scroll", l, { passive: !0 }), window.addEventListener("resize", l, { passive: !0 })), () => {
      u ? u.disconnect() : (window.removeEventListener("scroll", l), window.removeEventListener("resize", l)), c.current && cancelAnimationFrame(c.current);
    };
  }, [a, s, r, l]), n;
}, Et = t.object({
  template: t.literal("button"),
  variants: t.custom().optional(),
  buttonSettings: ue.optional(),
  mode: t.custom().optional(),
  targetSelector: t.string().optional(),
  selectSizeAction: t.union([t.literal("open-size-picker"), t.literal("scroll-to-size-picker")]).optional(),
  withSizePicker: t.boolean().optional(),
  sizePickerOverlayId: t.string().optional(),
  showPrice: t.boolean().optional()
}), Bs = P(
  "StickyAddToCartButton",
  y(
    {
      schema: Et,
      defaultProps: {
        template: "button",
        mode: "isScrolledPast",
        targetSelector: "#add-to-cart-component",
        selectSizeAction: "scroll-to-size-picker",
        withSizePicker: !1,
        sizePickerOverlayId: "size-picker-modal",
        showPrice: !0
      }
    },
    ({
      variants: a,
      buttonSettings: s,
      mode: n,
      targetSelector: o,
      selectSizeAction: i,
      withSizePicker: c,
      sizePickerOverlayId: r,
      showPrice: l
    }) => {
      const u = ba.styles(a), { addToCartMethod: h, isAvailable: f } = Ie(), v = De(), w = I(), { selectedOptions: g } = Me(), b = Object.values(g).filter((B) => !!B).map((B) => B.label).join(" / "), S = ye(), _ = As({
        targetSelector: o ?? "#add-to-cart-component",
        mode: n
      }), z = typeof window < "u" && window.location.pathname.includes("/checkout"), C = () => {
        ce.emit("open", {
          overlayId: r ?? "size-picker-modal"
        });
      }, x = async () => {
        if (!f) {
          if (i === "open-size-picker") {
            C();
            return;
          }
          if (i === "scroll-to-size-picker") {
            const B = document.getElementById("add-to-cart-component");
            B == null || B.scrollIntoView({
              behavior: "smooth",
              block: "end"
            });
            return;
          }
        }
        await h.execute(), z || ce.emit("open", { overlayId: "mini-cart" });
      };
      return v.status === "out-of-stock" ? null : c ? /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": _ ? "true" : "false",
          children: /* @__PURE__ */ p("div", { className: u.buttonsWrapper, children: [
            /* @__PURE__ */ e(
              se,
              {
                as: "button",
                variants: {
                  width: "full",
                  style: "outline",
                  color: "black"
                },
                label: f ? b : w("PDP_Select_Size"),
                onClick: C
              }
            ),
            /* @__PURE__ */ e(
              se,
              {
                as: "button",
                variants: {
                  width: "full"
                },
                ...s,
                progress: h.loadingState,
                label: /* @__PURE__ */ p(X, { children: [
                  w("PDP_Add_To_Cart"),
                  l && /* @__PURE__ */ p(X, { children: [
                    " ",
                    /* @__PURE__ */ e("span", { children: S.price.formatted })
                  ] })
                ] }),
                onClick: x
              }
            )
          ] })
        }
      ) : /* @__PURE__ */ e(
        "div",
        {
          className: u.base,
          "data-is-visible": _ ? "true" : "false",
          children: /* @__PURE__ */ e(
            se,
            {
              as: "button",
              variants: {
                width: "full",
                justifyContent: "between"
              },
              ...s,
              progress: h.loadingState,
              label: /* @__PURE__ */ p(X, { children: [
                w(f ? "PDP_Add_To_Cart" : "PDP_Select_Size"),
                l && /* @__PURE__ */ p(X, { children: [
                  " ",
                  /* @__PURE__ */ e("span", { children: S.price.formatted })
                ] })
              ] }),
              onClick: x
            }
          )
        }
      );
    }
  )
), Ds = t.discriminatedUnion("template", [
  Et
]), Is = P(
  "ProductStickyAddToCart",
  y(Ds, (a) => Q() !== "with_variants" ? null : a.template === "button" ? /* @__PURE__ */ e(Bs, { ...a }) : null)
), zs = () => Q() !== "bundle" ? null : /* @__PURE__ */ e(Ls, {}), Ls = () => {
  const { sections: a } = Ke(), s = Ce.styles();
  return /* @__PURE__ */ p("div", { className: s.base, children: [
    /* @__PURE__ */ e("div", { className: s.sectionsWrapper, children: Object.values(a).map((n, o) => /* @__PURE__ */ e(
      je,
      {
        product: n.activeProduct.product,
        context: {
          type: "plp",
          listId: "bundle-section",
          listName: "Bundle Section",
          position: o
        },
        children: /* @__PURE__ */ e(xs, { section: n, index: o })
      },
      o
    )) }),
    /* @__PURE__ */ e(Gs, {}),
    /* @__PURE__ */ e(Ws, {})
  ] });
}, xs = ({
  section: a,
  index: s
}) => {
  const n = E(), { selectSectionProduct: o } = Ke(), i = Ce.styles(), c = I(), r = (l) => {
    o(a.sectionId, l);
  };
  return /* @__PURE__ */ p("div", { className: i.section, children: [
    /* @__PURE__ */ e(de, { mode: "wait", initial: !1, children: /* @__PURE__ */ e("div", { className: i.productNameWrapper, children: /* @__PURE__ */ e(
      J.h3,
      {
        className: i.productName,
        exit: {
          y: "-100%"
        },
        initial: {
          y: "100%"
        },
        animate: {
          y: 0
        },
        transition: {
          duration: 0.35,
          ease: ot(0.32, 0.72, 0, 1)
        },
        children: c("PDP_Bundle_Selection_Product", {
          index: s + 1,
          product: n.content.name
        })
      }
    ) }, n.content.name) }),
    /* @__PURE__ */ e("h3", { className: i.selectionHeading, children: c("PDP_Bundle_Selection_Heading") }),
    /* @__PURE__ */ e("div", { className: i.productSlider, children: a.products.map((l, u) => {
      const h = l.base.productId === a.activeProduct.product.base.productId;
      return /* @__PURE__ */ e(
        Rs,
        {
          product: l,
          isSelected: h,
          onClick: () => r(l)
        },
        u
      );
    }) }),
    /* @__PURE__ */ e(Es, { sectionId: a.sectionId }),
    /* @__PURE__ */ e(
      Ya,
      {
        link: { href: a.activeProduct.product.base.slug },
        label: c("PDP_Bundle_Selection_Link"),
        className: i.link
      }
    )
  ] });
}, Rs = ({
  product: a,
  isSelected: s,
  onClick: n
}) => {
  var l;
  const o = Ce.styles(), i = (l = a.base.content.media) == null ? void 0 : l[0], r = ee(a.base)("product_color", t.string());
  return /* @__PURE__ */ p(
    "button",
    {
      className: o.productWrapper,
      onClick: n,
      "data-is-selected": s ? "true" : "false",
      children: [
        i && /* @__PURE__ */ e(te, { className: o.productImage, image: i }),
        r && /* @__PURE__ */ p("div", { className: o.swatchWrapper, children: [
          /* @__PURE__ */ e(
            It,
            {
              sibling: a.base,
              colorSwatchAttributeKey: "colorSwatch",
              className: o.swatch
            }
          ),
          /* @__PURE__ */ e("span", { className: o.swatchLabel, children: r == null ? void 0 : r.valueLabel })
        ] })
      ]
    }
  );
}, Es = ({ sectionId: a }) => {
  const s = Q(), n = De(), { selectSectionSize: o } = Ke(), i = I(), c = n.status === "available" ? n.availableItemId : void 0;
  switch (U(() => {
    o(a, c);
  }, [c]), s) {
    case "with_variants":
      return /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" });
    case "simple":
      return /* @__PURE__ */ e(
        "button",
        {
          "data-is-selected": n.status === "out-of-stock" ? "false" : "true",
          "data-is-out-of-stock": n.status === "out-of-stock" ? "true" : "false",
          className: "w-1/2 h-10 text-label-sm uppercase font-medium bg-transparent rounded-md border data-[is-out-of-stock=true]:text-less-emphasis-3 data-[is-selected=true]:text-white data-[is-selected=true]:bg-black relative data-[is-out-of-stock=true]:before:absolute data-[is-out-of-stock=true]:before:w-[1px] data-[is-out-of-stock=true]:before:h-[140%] data-[is-out-of-stock=true]:before:bg-less-emphasis-3 data-[is-out-of-stock=true]:before:top-[-20%] before:left-1/2 before:-translate-x-1/2 before:rotate-45 [&>svg]:w-5 [&>svg]:h-5",
          children: i("PDP_Size_Picker_One_Size")
        }
      );
    default:
      return null;
  }
}, Gs = () => {
  const a = Ae(), s = Ce.styles(), n = I();
  return /* @__PURE__ */ p("div", { className: s.totalsWrapper, children: [
    /* @__PURE__ */ p("div", { className: s.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: s.totalsLabel, children: n("PDP_Bundle_Discount_Label") }),
      /* @__PURE__ */ p("span", { className: s.totalsValue, children: [
        "-",
        a.discountFromPriceOfItemsOutsideBundle.formatted
      ] })
    ] }),
    /* @__PURE__ */ p("div", { className: s.totalsRow, children: [
      /* @__PURE__ */ e("span", { className: s.totalsLabel, children: n("PDP_Bundle_Price_Label") }),
      /* @__PURE__ */ e("span", { className: s.totalsValue, children: a.priceInfo.price.formatted })
    ] })
  ] });
}, Ws = () => {
  const a = za(), s = La(), { execute: n } = Ka("addBundleToCart"), [o, i] = R.useState("default"), c = I(), r = async () => {
    if (s.status === "available")
      try {
        i("loading"), await n({
          itemId: a,
          sections: s.sections.map((u) => ({
            sectionId: u.sectionId,
            itemId: u.availableItemId
          }))
        }), await new Promise((u) => setTimeout(u, 1e3)), i("complete"), await new Promise((u) => setTimeout(u, 1e3));
      } catch {
        i("default"), await new Promise((h) => setTimeout(h, 1e3));
      } finally {
        i("default"), ce.emit("open", { overlayId: "mini-cart" });
      }
  }, l = s.status === "available";
  return /* @__PURE__ */ e(
    se,
    {
      as: "button",
      variants: {
        width: "full"
      },
      progress: o,
      "aria-disabled": l ? "false" : "true",
      label: c(At[s.status]),
      onClick: r
    }
  );
}, me = t.object({
  items: t.array(
    t.object({
      label: t.string().optional(),
      icon: t.custom().optional()
    })
  ).optional(),
  attributeKey: t.string().optional(),
  variants: t.custom().optional()
}), Os = P(
  "ProductUspBlock",
  y(
    {
      schema: me,
      defaultProps: {
        attributeKey: "usps"
      }
    },
    ({ items: a, variants: s, attributeKey: n }) => {
      var c, r;
      const o = ga.styles(s), i = (c = K(
        n ?? "usps",
        t.array(
          t.object({
            label: t.string(),
            icon: t.string().optional()
          })
        )
      )) == null ? void 0 : c.value;
      return !a && !i ? null : /* @__PURE__ */ e("div", { className: o.base, children: (r = a ?? i) == null ? void 0 : r.map((l, u) => /* @__PURE__ */ p("div", { className: o.item, children: [
        l.icon,
        /* @__PURE__ */ e("span", { className: o.label, children: l.label })
      ] }, u)) });
    }
  )
), Gt = t.object({
  template: t.literal("scale"),
  variants: t.custom().optional(),
  /**
   * On a scale of. @default 10
   * @type {number}
   *  */
  onAScaleOf: t.number().optional()
}), js = P(
  "ProductSizeRecommendationScale",
  y(
    {
      schema: Gt,
      defaultProps: {
        template: "scale",
        onAScaleOf: 10
      }
    },
    ({ onAScaleOf: a }) => {
      E();
      const s = fa.styles(), n = I(), o = K(
        "sizeRecommendation",
        t.string()
      ), i = K(
        "sizeRecommendationScale",
        t.string()
      );
      if (!(!(i != null && i.value) || !(o != null && o.value)))
        return /* @__PURE__ */ p("div", { className: s.base, children: [
          (i == null ? void 0 : i.value) && i.value && /* @__PURE__ */ p(X, { children: [
            /* @__PURE__ */ e("h3", { className: s.label, children: n("PDP_Size_Recommendation_Scale_Label") }),
            /* @__PURE__ */ e("div", { className: s.bar, children: /* @__PURE__ */ e(
              J.div,
              {
                className: s.dot,
                initial: {
                  left: `${parseInt(i.value) / (a ?? 10) * 100}%`,
                  scale: 0
                },
                whileInView: {
                  scale: 1
                },
                transition: {
                  delay: 0.25
                },
                exit: { scale: 0 }
              }
            ) }),
            /* @__PURE__ */ p("div", { className: s.scaleLabels, children: [
              /* @__PURE__ */ e("span", { className: s.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Small") }),
              /* @__PURE__ */ e("span", { className: s.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Perfect") }),
              /* @__PURE__ */ e("span", { className: s.scaleLabel, children: n("PDP_Size_Recommendation_Scale_Big") })
            ] })
          ] }),
          (o == null ? void 0 : o.value) && /* @__PURE__ */ e("span", { className: s.sizeText, children: o.value })
        ] });
    }
  )
), Ms = t.discriminatedUnion("template", [
  Gt
]), Ks = P(
  "SizeRecommendation",
  y(Ms, (a) => {
    if (a.template === "scale")
      return /* @__PURE__ */ e(js, { ...a });
  })
), Hs = t.object({
  variants: t.custom().optional(),
  template: t.enum(["button", "text"]).optional(),
  buttonVariants: Za.shape.variants.optional()
}), Vs = P(
  "ProductBundleUpsell",
  y(
    {
      schema: Hs,
      defaultProps: {
        template: "button",
        buttonVariants: {
          width: "full",
          color: "black",
          style: "outline"
        }
      }
    },
    ({ variants: a, buttonVariants: s, template: n }) => {
      const o = Be("bundle")[0], i = I(), c = va.styles(a);
      return o ? /* @__PURE__ */ e(
        Pe,
        {
          productBase: o.product.base,
          className: c.base,
          children: n === "button" ? /* @__PURE__ */ e(
            it,
            {
              label: i("PDP_Bundle_Upsell_Title", {
                // Add support for discount when it exists.
                name: o.product.base.content.name
              }),
              variants: s
            }
          ) : /* @__PURE__ */ e("span", { children: i("PDP_Bundle_Upsell_Title", {
            name: o.product.base.content.name
          }) })
        }
      ) : null;
    }
  )
), Wt = t.object({
  heading: t.string().optional(),
  subtitle: t.string().optional(),
  image: tt.optional().nullable(),
  condition: t.string().optional(),
  variants: t.custom().optional()
}), Us = P(
  "ProductGiftWithPurchase",
  y(
    {
      schema: Wt,
      defaultProps: {
        image: {
          displaySize: "5vw"
        }
      }
    },
    ({ heading: a, subtitle: s, image: n, variants: o, condition: i }) => {
      var r;
      const c = Pa.styles(o);
      return !a && !s && !n ? null : /* @__PURE__ */ p("div", { className: c.base, children: [
        /* @__PURE__ */ p("div", { className: c.contentWrapper, children: [
          n && ((r = n.image) == null ? void 0 : r.src) && /* @__PURE__ */ e(te, { ...n, className: c.image }),
          /* @__PURE__ */ p("div", { className: c.textWrapper, children: [
            a && /* @__PURE__ */ e("h3", { className: c.heading, children: a }),
            s && /* @__PURE__ */ e(nn, { content: s, className: c.subtitle })
          ] })
        ] }),
        i && /* @__PURE__ */ e("span", { className: c.condition, children: i })
      ] });
    }
  )
), Ot = t.object({
  template: t.literal("cairo"),
  variants: t.custom().optional(),
  content: t.custom()
}), $s = P(
  "SizeGuideContent",
  y(Ot, ({ variants: a, content: s }) => {
    const n = ya.styles(a);
    return /* @__PURE__ */ e(sn.Provider, { value: !0, children: /* @__PURE__ */ e("div", { className: n.contentWrapper, children: s }) });
  })
), jt = t.object({
  template: t.literal("drawer"),
  contentSettings: Ot.optional(),
  drawerSettings: t.custom().optional(),
  enabled: t.boolean().optional(),
  applyButtonSettings: We.optional(),
  closeButtonSettings: We.optional()
}), Fs = "cairo", Ys = 1024, Xs = P(
  "SizeGuideDrawer",
  y(jt, (a) => {
    Sa.styles(), I();
    const s = a.contentSettings || {
      template: Fs
    };
    if (!a.enabled)
      return null;
    const [n, o] = $(!1);
    return U(() => {
      const i = () => {
        o(window.innerWidth > Ys);
      };
      return window.addEventListener("resize", i), i(), () => {
        window.removeEventListener("resize", i);
      };
    }, []), /* @__PURE__ */ e(
      W,
      {
        customOverlayId: "size-guide",
        hasOverlay: !0,
        hasScaledBackground: !0,
        setBackgroundColorOnScale: !1,
        hasHandle: !n,
        variants: {
          dragHandle: n ? "false" : "true",
          rounded: n ? "none" : "strong",
          background: "white",
          direction: n ? "right" : "bottom"
        },
        direction: n ? "right" : "bottom",
        ...a.drawerSettings,
        children: /* @__PURE__ */ e(W.Content, { children: /* @__PURE__ */ e($s, { ...s }) })
      }
    );
  })
), Le = t.discriminatedUnion("template", [
  jt
]), Qs = P(
  "SizeGuide",
  y(Le, (a) => {
    switch (a.template) {
      case "drawer":
        return /* @__PURE__ */ e(Xs, { ...a });
      default:
        return null;
    }
  })
), xe = t.object({
  link: Xa.optional(),
  label: t.string().optional(),
  icon: t.custom().optional(),
  variants: t.custom().optional()
}), Zs = P(
  "SizeGuideTrigger",
  y(xe, ({ variants: a, label: s, link: n, icon: o }) => {
    const i = wa.styles(a);
    return /* @__PURE__ */ e(
      Qa,
      {
        onClick: () => ce.emit("open", { overlayId: "size-guide" }),
        className: i.trigger,
        label: s,
        icon: o,
        ...n
      }
    );
  })
), qs = t.object({
  variants: t.custom().optional()
}), Js = ({ variants: a }) => {
  const s = I(), n = _a.styles(a), o = Ae(), i = o.discountFromPriceOfItemsOutsideBundle.formatted, c = o.discountFromPriceOfItemsOutsideBundle.number;
  return !i || c <= 0 ? null : /* @__PURE__ */ p("div", { className: n.base, children: [
    /* @__PURE__ */ e("h3", { className: n.heading, children: s("PDP_Bundle_Promo_Banner_Heading", {
      bundleSavings: i
    }) }),
    /* @__PURE__ */ e("p", { className: n.text, children: s("PDP_Bundle_Promo_Banner_Text") })
  ] });
}, eo = P(
  "ProductBundlePromoBanner",
  y(
    {
      schema: qs,
      defaultProps: {}
    },
    (a) => Q() !== "bundle" ? null : /* @__PURE__ */ e(Js, { ...a })
  )
), m = {
  SizeGuide: Qs,
  Details: zn,
  Root: gn,
  ImageGallery: Fn,
  AddToCart: ds,
  Specifications: Xn,
  Attributes: as,
  SizePicker: fs,
  Siblings: ks,
  RelatedProducts: Cs,
  StickyAddToCart: Is,
  Bundle: zs,
  BundleUpsell: Vs,
  UspBlock: Os,
  SizeGuideTrigger: Zs,
  SizeRecommendation: Ks,
  GiftWithPurchase: Us,
  BundlePromoBanner: eo,
  PriceHistoryDrawer: kn
  // Add other components as needed
}, Mt = t.object({
  template: t.literal("basic"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: Le.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  belowTheFoldComponents: t.custom().optional()
}), to = P(
  "ProductTemplateAsBasic",
  y(
    {
      schema: Mt,
      defaultProps: {
        template: "basic",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: s,
      uspBlockSettings: n,
      siblingsPickerSettings: o,
      sizeGuideSettings: i,
      sizeGuideTriggerSettings: c,
      belowTheFoldComponents: r
    }) => {
      var f;
      const l = E(), u = ka.styles(), h = I();
      return /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: l.productId,
          className: u.base,
          children: [
            /* @__PURE__ */ e(
              oe,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden ml-3 mb-3"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "number" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: u.detailsWrapper, children: [
              /* @__PURE__ */ e(
                oe,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block mb-4"
                }
              ),
              /* @__PURE__ */ e(m.Details.Brand, {}),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "image-card",
                  ...o
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...i }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...s,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...c,
                      label: h("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(m.AddToCart, { template: "button" }),
              /* @__PURE__ */ e(m.UspBlock, { ...n }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: h("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: u.belowTheFoldDetails, children: [
              /* @__PURE__ */ e(
                m.Details.Description,
                {
                  label: h("PDP_Product_Description_Label")
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0,
                        defaultValue: "details"
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        trigger: h("PDP_Product_Details"),
                        value: "details",
                        content: l.content.description
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Material"),
                        attributeKey: "material"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        trigger: h("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ e("div", { className: u.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(f = a == null ? void 0 : a.swiperSettings) == null ? void 0 : f.settings,
                    headerSettings: {
                      heading: {
                        heading: h("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            r
          ]
        }
      ) });
    }
  )
), Kt = t.object({
  template: t.literal("helsinki"),
  breadcrumbsSettings: on.optional(),
  imageGallerySettings: wt.optional(),
  addToCartSettings: Dt.optional(),
  descriptionSettings: Ve.optional(),
  specificationSettings: kt.optional(),
  progressBarSettings: $e.optional(),
  tagsSettings: t.array(Fe).optional(),
  relatedProductsSettings: ie.optional(),
  discontinuedBadgeWrapper: st.optional(),
  shippingBarometer: rn.optional(),
  id: t.string().optional()
}), ao = P(
  "ProductPageTemplateHelsinki",
  y(
    {
      schema: Kt,
      defaultProps: {
        template: "helsinki",
        breadcrumbsSettings: {
          variants: {
            isOn: "pdp"
          }
        },
        discontinuedBadgeWrapper: {
          rotate: "randomize"
          // variants: {
          //   color: "red",
          // },
        },
        imageGallerySettings: {
          template: "keen",
          indicator: "dots"
        },
        addToCartSettings: {
          template: "quantity-picker"
        },
        descriptionSettings: {
          readMoreSettings: {
            enabled: !0,
            limit: 160
          }
        },
        specificationSettings: {
          template: "table"
        },
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      breadcrumbsSettings: a,
      imageGallerySettings: s,
      addToCartSettings: n,
      descriptionSettings: o,
      specificationSettings: i,
      progressBarSettings: c,
      tagsSettings: r,
      relatedProductsSettings: l,
      discontinuedBadgeWrapper: u,
      shippingBarometer: h,
      id: f
    }) => {
      var b;
      const { status: v } = De(), w = I(), g = Na.styles();
      return /* @__PURE__ */ p(
        "section",
        {
          id: f,
          className: "grid-cols-12 lg:grid-rows-[min-content_max-content] grid lg:gap-4 w-full lg:gap-y-12 bg-white lg:px-8 rounded-lg lg:max-h-[90vh] overflow-y-scroll",
          children: [
            /* @__PURE__ */ p(m.ImageGallery, { ...s, template: "keen", children: [
              /* @__PURE__ */ e(
                oe,
                {
                  ...a,
                  layout: {
                    spacing: { applySpacing: "false" },
                    position: { applyPosition: "false" }
                  }
                }
              ),
              v === "discontinued" && /* @__PURE__ */ e("div", { className: g.discountinuedBadgeWrapper, children: /* @__PURE__ */ e(
                He,
                {
                  label: w("PDP_Discontinued_Badge"),
                  ...u
                }
              ) })
            ] }),
            /* @__PURE__ */ p("div", { className: g.addToCartWrapper, children: [
              /* @__PURE__ */ e(m.Details.Name, {}),
              v === "out-of-stock" && /* @__PURE__ */ p("div", { className: g.outOfStock, children: [
                /* @__PURE__ */ e("span", { className: g.outOfStockIndicator }),
                /* @__PURE__ */ e("span", { children: w("PDP_Out_Of_Stock") })
              ] }),
              v === "discontinued" && /* @__PURE__ */ p("div", { className: g.discontinued, children: [
                /* @__PURE__ */ e("span", { className: g.discontinuedIndicator }),
                /* @__PURE__ */ e("span", { children: w("PDP_Discontinued_Message") })
              ] }),
              v !== "discontinued" && /* @__PURE__ */ e(
                m.AddToCart,
                {
                  ...n ?? { template: "quantity-picker" }
                }
              ),
              /* @__PURE__ */ e(
                ln,
                {
                  ...h,
                  className: g.shippingBarometer
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: g.detailsWrapper, children: [
              /* @__PURE__ */ e(m.Details.ShortDescription, {}),
              /* @__PURE__ */ e(m.Details.Description, { ...o }),
              /* @__PURE__ */ e(
                m.Specifications,
                {
                  ...i ?? { template: "table" }
                }
              )
            ] }),
            /* @__PURE__ */ p("div", { className: g.attributesWrapper, children: [
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  template: "progress-bar",
                  ...c
                }
              ),
              r && /* @__PURE__ */ e("div", { className: g.tags, children: r.map((S, _) => /* @__PURE__ */ e(m.Attributes, { ...S }, _)) })
            ] }),
            /* @__PURE__ */ e("div", { className: g.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(b = l == null ? void 0 : l.swiperSettings) == null ? void 0 : b.settings,
                    headerSettings: {
                      heading: {
                        heading: w("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      );
    }
  )
), Ht = t.object({
  template: t.literal("malibu"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  relatedProductsSettings: ie.optional(),
  siblingSettings: Ye.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  giftWithPurchaseSettings: Wt.optional(),
  extendAccordion: t.array(bt).optional(),
  sizeGuideSettings: Le.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  priceSettings: ht.optional(),
  belowTheFoldComponents: t.custom().optional(),
  reviewComponentSlot: t.custom().optional(),
  sizeFinderSlot: t.custom().optional(),
  sizeFinderSlotPosition: t.enum(["above-atc", "below-atc"]).optional(),
  openFirstAccordionItem: t.boolean().optional(),
  alwaysShowStickyAddToCart: t.boolean().optional(),
  tagsComponentSlot: t.custom().optional(),
  bundleUpsell: t.custom().optional(),
  accordionRootSettings: t.custom().optional(),
  bundleDisplayStyle: t.enum(["card", "text"]).optional(),
  enableImageGalleryZoom: t.boolean().optional()
}), no = P(
  "ProductTemplateAsMalibu",
  y(
    {
      schema: Ht,
      defaultProps: {
        template: "malibu",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              itemsInView: {
                initial: "2.1",
                lg: "4.2",
                xl: "5"
              },
              variants: {
                layout: "stacked",
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: s,
      siblingSettings: n,
      sizePickerSettings: o,
      uspBlockSettings: i,
      extendAccordion: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      giftWithPurchaseSettings: u,
      priceSettings: h,
      belowTheFoldComponents: f,
      reviewComponentSlot: v,
      accordionRootSettings: w,
      sizeFinderSlot: g,
      bundleUpsell: b,
      sizeFinderSlotPosition: S,
      tagsComponentSlot: _,
      openFirstAccordionItem: z,
      alwaysShowStickyAddToCart: C,
      bundleDisplayStyle: x,
      enableImageGalleryZoom: B
    }) => {
      var V;
      const G = E(), F = Ta.styles(), d = I(), L = K("fit_text", t.string()), [M, O] = $(
        void 0
      );
      return U(() => {
        const H = () => O("reviews");
        return window.addEventListener("pdp:open-reviews", H), () => window.removeEventListener("pdp:open-reviews", H);
      }, []), /* @__PURE__ */ p("section", { className: F.base, children: [
        /* @__PURE__ */ e(ct, { template: "drawer" }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            zoom: B
          }
        ),
        /* @__PURE__ */ e(
          m.StickyAddToCart,
          {
            template: "button",
            mode: C ? "isNotVisible" : "isScrolledPast"
          }
        ),
        /* @__PURE__ */ e(m.ImageGallery, { template: "grid", zoom: B }),
        /* @__PURE__ */ p("section", { className: F.detailsWrapper, children: [
          /* @__PURE__ */ e(
            oe,
            {
              enableWrapper: !1,
              variants: { isOn: "pdp" },
              layout: {
                spacing: { applySpacing: "false" },
                position: { applyPosition: "false" }
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(
            m.Details.Price,
            {
              ...h,
              priceHistoryDrawerSettings: {
                isEnabled: !0,
                trigger: /* @__PURE__ */ e(cn, { className: "w-3 h-3 lg:w-4 lg:h-4 fill-[#71717a]" })
              }
            }
          ),
          /* @__PURE__ */ e(m.Details.ProductType, { ...s }),
          v,
          _,
          /* @__PURE__ */ e(m.Siblings, { template: "image-card", ...n }),
          /* @__PURE__ */ e(
            m.SizePicker,
            {
              template: "button-grid",
              ...o
            }
          ),
          /* @__PURE__ */ e(m.BundlePromoBanner, {}),
          /* @__PURE__ */ e(m.Bundle, {}),
          S !== "below-atc" && g && g,
          /* @__PURE__ */ e(
            m.AddToCart,
            {
              template: "button",
              isNotifyMeEnabled: (V = o == null ? void 0 : o.notifyMe) == null ? void 0 : V.enabled
            }
          ),
          S === "below-atc" && g && g,
          x === "text" && /* @__PURE__ */ e(m.BundleUpsell, {}),
          (L == null ? void 0 : L.value) && /* @__PURE__ */ e("span", { className: F.fitText, children: L.value }),
          /* @__PURE__ */ e(m.SizeRecommendation, { template: "scale" }),
          (r == null ? void 0 : r.enabled) && /* @__PURE__ */ e(
            m.SizeGuideTrigger,
            {
              ...l,
              label: d("Size_Guide_Trigger_Label")
            }
          ),
          /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
          /* @__PURE__ */ e(m.UspBlock, { ...i }),
          /* @__PURE__ */ e(m.GiftWithPurchase, { ...u }),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "icon-blocks",
              attributeKey: "productFeaturesVariant"
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Accordion,
            {
              items: [
                {
                  content: {
                    trigger: d("PDP_Product_Description"),
                    value: "description",
                    forceMount: !0,
                    content: G.content.description
                  }
                },
                {
                  content: {
                    trigger: d("PDP_Fabric_Care"),
                    attributeKey: "fabricCare_text",
                    forceMount: !0
                  }
                },
                {
                  content: {
                    trigger: d("PDP_Product_Details"),
                    forceMount: !0,
                    content: G.content.shortDescription
                  }
                },
                ...c ?? []
              ],
              settings: {
                radixAccordionSettings: {
                  root: w ?? {
                    type: "single",
                    value: M,
                    defaultValue: z ? "description" : void 0,
                    onValueChange: (H) => O(H)
                  }
                }
              }
            }
          ),
          x === "card" && b
        ] }),
        f
      ] });
    }
  )
), Vt = t.object({
  template: t.literal("vienna"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  sizePicker2Settings: ve.optional(),
  uspBlockSettings: me.optional(),
  imageGallerySettings: ze.optional(),
  siblingsPickerSettings: we.optional(),
  reviewCarouselComponent: t.custom().optional(),
  reviewStarsComponent: t.custom().optional(),
  detailsComponentSlot: t.custom().optional(),
  sizeGuideComponentSlot: t.custom().optional(),
  beforeSiblingsSlot: t.custom().optional(),
  afterSiblingsSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional(),
  afterAddToCartSlot: t.custom().optional(),
  afterAttributesSlot: t.custom().optional(),
  washingInstructionDrawer: t.custom().optional()
}), so = () => /* @__PURE__ */ e(m.AddToCart, { template: "button" }), oo = ({
  sizePickerSettings: a,
  sizePicker2Settings: s
}) => {
  const n = I(), o = xa();
  return /* @__PURE__ */ e(X, { children: o ? /* @__PURE__ */ p(X, { children: [
    /* @__PURE__ */ e(m.SizePicker, { ...a, template: "modal" }),
    /* @__PURE__ */ e(
      m.SizePicker,
      {
        ...s,
        template: "modal",
        triggerLabel: n("PDP_Add_To_Cart"),
        customOverlayId: "size-picker-modal-2"
      }
    )
  ] }) : /* @__PURE__ */ e(
    fe,
    {
      label: n("PDP_Out_Of_Stock"),
      disabled: !0,
      "aria-disabled": "true",
      variants: {
        width: "full"
      }
    }
  ) });
}, io = P(
  "ProductTemplateAsVienna",
  y(
    {
      schema: Vt,
      defaultProps: {
        template: "vienna",
        sizePickerSettings: {
          template: "modal",
          buttonVariants: {
            color: "black",
            style: "outline",
            width: "full"
          }
        },
        sizePicker2Settings: {
          template: "modal",
          buttonVariants: {
            style: "solid",
            width: "full"
          }
        },
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      relatedProductsSettings: a,
      sizePickerSettings: s,
      sizePicker2Settings: n,
      uspBlockSettings: o,
      imageGallerySettings: i,
      siblingsPickerSettings: c,
      detailsComponentSlot: r,
      reviewStarsComponent: l,
      sizeGuideComponentSlot: u,
      beforeSiblingsSlot: h,
      afterSiblingsSlot: f,
      belowTheFoldComponents: v,
      washingInstructionDrawer: w,
      afterAddToCartSlot: g,
      afterAttributesSlot: b
    }) => {
      var L, M, O, V, H, q;
      const S = E(), _ = Ca.styles(), z = I(), C = Q(), x = (L = K(
        "product_highlight_text",
        t.string()
      )) == null ? void 0 : L.value, B = (M = K(
        "pr_video_url",
        t.string()
      )) == null ? void 0 : M.value, G = (O = K("pr_badge", t.string().array())) == null ? void 0 : O.value, F = (V = K(
        "washing_advice_text",
        t.string()
      )) == null ? void 0 : V.value, d = C === "simple";
      return /* @__PURE__ */ p("section", { className: _.base, children: [
        /* @__PURE__ */ e("div", { className: _.breadcrumbsWrapper, children: /* @__PURE__ */ e(
          oe,
          {
            layout: {
              spacing: { applySpacing: "false" },
              position: { applyPosition: "false" }
            }
          }
        ) }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            buttonInSlider: {
              enabled: !!(B && (B == null ? void 0 : B.length) > 0),
              onClick: () => {
                const T = document == null ? void 0 : document.getElementById("youtube-video");
                T && T.scrollIntoView({ behavior: "smooth" });
              },
              label: z("Product_Video_Button_Text")
            },
            ...i,
            children: /* @__PURE__ */ e("div", { className: _.badgesWrapper, children: G == null ? void 0 : G.map((T, D) => /* @__PURE__ */ e(He, { label: T }, D)) })
          }
        ),
        /* @__PURE__ */ p("section", { className: _.detailsWrapper, children: [
          /* @__PURE__ */ p("div", { className: "flex flex-row justify-between items-center lg:mt-0 mb-2", children: [
            /* @__PURE__ */ p("div", { className: "flex items-center empty:hidden flex-wrap", children: [
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "wiring" }),
              ((H = K("wiring", t.string())) == null ? void 0 : H.value) && ((q = K("padding", t.string())) == null ? void 0 : q.value) && /* @__PURE__ */ e("span", { className: "m-1 mb-2", children: "•" }),
              /* @__PURE__ */ e(m.Details.ProductType, { attributeKey: "padding" })
            ] }),
            l
          ] }),
          /* @__PURE__ */ e(m.Details.Name, {}),
          /* @__PURE__ */ e(m.Details.Price, {}),
          h,
          /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...c
            }
          ),
          f,
          /* @__PURE__ */ p("div", { className: "flex flex-col gap-2", children: [
            u,
            /* @__PURE__ */ e(
              "div",
              {
                className: "w-full flex flex-row gap-4",
                id: "add-to-cart-component",
                children: d ? /* @__PURE__ */ e(so, {}) : /* @__PURE__ */ e(
                  oo,
                  {
                    sizePicker2Settings: n,
                    sizePickerSettings: s
                  }
                )
              }
            ),
            g
          ] }),
          /* @__PURE__ */ e(m.UspBlock, { ...o }),
          /* @__PURE__ */ e(
            m.StickyAddToCart,
            {
              template: "button",
              mode: "isNotVisible",
              selectSizeAction: "open-size-picker",
              withSizePicker: !0
            }
          )
        ] }),
        /* @__PURE__ */ e(m.Details.Description, {}),
        x && /* @__PURE__ */ e("ul", { className: _.highlightTextWrapper, children: x == null ? void 0 : x.split(";").map((T, D) => /* @__PURE__ */ e("li", { className: _.highlightTextRow, children: T }, D)) }),
        /* @__PURE__ */ p("section", { className: _.attributesWrapper, children: [
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "material_pdp_text"
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              data: {
                attributeLabel: z("washing_advice_text"),
                value: /* @__PURE__ */ p(X, { children: [
                  F,
                  " ",
                  w
                ] })
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "product_key",
              data: {
                attributeLabel: z("Article_Number"),
                value: S.productKey
              }
            }
          ),
          /* @__PURE__ */ e(
            m.Attributes,
            {
              template: "row",
              attributeKey: "hooks_and_eye_text"
            }
          )
        ] }),
        b,
        B && /* @__PURE__ */ e("div", { className: _.productVideo, id: "youtube-video", children: /* @__PURE__ */ e(
          "div",
          {
            className: "relative w-full",
            style: { paddingBottom: "56.25%" },
            children: /* @__PURE__ */ e(
              "iframe",
              {
                className: "absolute top-0 left-0 w-full h-full",
                src: B.includes("youtube.com/watch?v=") ? `https://www.youtube.com/embed/${B.split("v=")[1]}` : B,
                title: "Product video",
                frameBorder: "0",
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                allowFullScreen: !0
              }
            )
          }
        ) }),
        /* @__PURE__ */ e(
          m.RelatedProducts,
          {
            template: "image-cards",
            relationType: "standard",
            ...a
          }
        ),
        r,
        v
      ] });
    }
  )
), Ut = t.object({
  template: t.literal("graz"),
  variants: t.custom().optional(),
  productTypeSettings: pe.optional(),
  productDesignerSettings: pe.extend({
    link: t.string().optional()
  }).optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: Se.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  sizeGuideSettings: Le.optional(),
  sizeGuideTriggerSettings: xe.optional(),
  productSku: t.string().optional(),
  ecomidNudgeSlot: t.custom().optional(),
  belowTheFoldComponents: t.custom().optional()
}), ro = P(
  "ProductTemplateAsGraz",
  y(
    {
      schema: Ut,
      defaultProps: {
        template: "graz",
        relatedProductsSettings: {
          template: "swiper",
          swiperSettings: {
            settings: {
              template: "template1",
              itemsInView: {
                initial: "2.1",
                lg: "4",
                xl: "4"
              },
              spacing: {
                y: {
                  initial: "lg",
                  lg: "md",
                  xl: "md"
                }
              },
              variants: {
                background: { initial: "none", lg: "white" }
              }
            }
          }
        }
      }
    },
    ({
      relatedProductsSettings: a,
      productTypeSettings: s,
      productDesignerSettings: n,
      sizePickerSettings: o,
      uspBlockSettings: i,
      siblingsPickerSettings: c,
      sizeGuideSettings: r,
      sizeGuideTriggerSettings: l,
      ecomidNudgeSlot: u,
      belowTheFoldComponents: h,
      productSku: f
    }) => {
      var S, _, z;
      const v = E(), w = Aa.styles(), g = I(), b = dn();
      return /* @__PURE__ */ e(de, { mode: "wait", children: /* @__PURE__ */ p(
        J.section,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          exit: { opacity: 0 },
          id: v.productId,
          className: w.base,
          children: [
            /* @__PURE__ */ e(ct, { template: "drawer" }),
            /* @__PURE__ */ e(
              oe,
              {
                variants: { isOn: "pdp" },
                enableWrapper: !1,
                className: "block lg:hidden"
              }
            ),
            /* @__PURE__ */ e(m.ImageGallery, { template: "keen", indicator: "dots" }),
            /* @__PURE__ */ e(m.StickyAddToCart, { template: "button" }),
            /* @__PURE__ */ e(m.ImageGallery, { template: "grid" }),
            /* @__PURE__ */ p("section", { className: w.detailsWrapper, children: [
              /* @__PURE__ */ e(
                oe,
                {
                  variants: { isOn: "pdp" },
                  enableWrapper: !1,
                  className: "hidden lg:block"
                }
              ),
              /* @__PURE__ */ p("div", { className: w.tagsWrapper, children: [
                /* @__PURE__ */ e(m.Details.ProductType, { ...s }),
                /* @__PURE__ */ e(b, { href: (n == null ? void 0 : n.link) ?? "", children: /* @__PURE__ */ e(m.Details.ProductType, { ...n }) })
              ] }),
              /* @__PURE__ */ e(m.Details.Name, {}),
              /* @__PURE__ */ e(m.Details.Price, {}),
              /* @__PURE__ */ e(m.Attributes, { template: "tags", attributeKey: "sticker" }),
              /* @__PURE__ */ e(
                m.Siblings,
                {
                  template: "color-swatch",
                  ...c
                }
              ),
              /* @__PURE__ */ e(m.SizeGuide, { template: "drawer", ...r }),
              /* @__PURE__ */ e(
                m.SizePicker,
                {
                  template: "button-grid",
                  ...o,
                  headerContent: /* @__PURE__ */ e(
                    m.SizeGuideTrigger,
                    {
                      ...l,
                      label: g("Size_Guide_Trigger_Label")
                    }
                  )
                }
              ),
              /* @__PURE__ */ e(
                m.AddToCart,
                {
                  template: "button",
                  isNotifyMeEnabled: (S = o == null ? void 0 : o.notifyMe) == null ? void 0 : S.enabled
                }
              ),
              /* @__PURE__ */ e(m.UspBlock, { ...i }),
              /* @__PURE__ */ e("div", { className: w.retracedIcons, children: /* @__PURE__ */ e("retraced-icons", {}) }),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: g("PDP_Product_Features_Label"),
                  template: "icon-blocks",
                  attributeKey: "productFeatures"
                }
              ),
              /* @__PURE__ */ e(
                m.Details.Accordion,
                {
                  settings: {
                    radixAccordionSettings: {
                      root: {
                        type: "single",
                        collapsible: !0
                      }
                    }
                  },
                  items: [
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_Details"),
                        content: v.content.description
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Fabric_Care"),
                        attributeKey: "fabricCare_text"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_Material"),
                        attributeKey: "pr_fabric"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_Manufacturer"),
                        attributeKey: "supplier"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_CareGuide"),
                        attributeKey: "care_guide"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_Manufacturer"),
                        attributeKey: "manufacturer"
                      }
                    },
                    {
                      content: {
                        forceMount: !0,
                        trigger: g("PDP_Product_Shipping"),
                        attributeKey: "shipping"
                      }
                    }
                  ]
                }
              ),
              /* @__PURE__ */ e(
                m.Attributes,
                {
                  label: g("PDP_Product_Certifications"),
                  template: "icon-blocks",
                  attributeKey: "certifications"
                }
              ),
              u,
              /* @__PURE__ */ e("span", { className: w.productId, children: g("PDP_Product_Id", {
                productId: v.productId,
                sku: f || ""
              }) })
            ] }),
            /* @__PURE__ */ e("div", { className: w.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(_ = a == null ? void 0 : a.swiperSettings) == null ? void 0 : _.settings,
                    headerSettings: {
                      heading: {
                        heading: g("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) }),
            h,
            /* @__PURE__ */ e("div", { className: w.relatedProductsWrapper, children: /* @__PURE__ */ e(
              m.RelatedProducts,
              {
                template: "swiper",
                swiperSettings: {
                  settings: {
                    template: "template1",
                    ...(z = a == null ? void 0 : a.swiperSettings) == null ? void 0 : z.settings,
                    headerSettings: {
                      heading: {
                        heading: g("PDP_Related_Products_Header")
                      }
                    }
                  }
                }
              }
            ) })
          ]
        }
      ) });
    }
  )
), $t = t.object({
  template: t.literal("salzburg"),
  variants: t.custom().optional(),
  relatedProductsSettings: ie.optional(),
  sizePickerSettings: ve.optional(),
  uspBlockSettings: me.optional(),
  siblingsPickerSettings: we.optional(),
  imageGallerySettings: ze.optional(),
  descriptionSettings: Ve.optional(),
  nameSettings: pt.optional(),
  customSiblings: t.custom().optional()
}), lo = P(
  "ProductTemplateAsSalzburg",
  y(
    {
      schema: $t,
      defaultProps: {
        template: "salzburg",
        relatedProductsSettings: {
          template: "image-cards"
        }
      }
    },
    ({
      sizePickerSettings: a,
      imageGallerySettings: s,
      nameSettings: n,
      descriptionSettings: o,
      siblingsPickerSettings: i,
      variants: c,
      customSiblings: r
    }) => {
      const l = ge.main.styles(c), u = I();
      return /* @__PURE__ */ p("section", { className: l.base, children: [
        /* @__PURE__ */ p("section", { className: l.detailsWrapper, children: [
          /* @__PURE__ */ e(
            m.Details.Name,
            {
              ...n,
              blueprint: ge.details
            }
          ),
          /* @__PURE__ */ e(
            m.Details.Description,
            {
              ...o,
              blueprint: ge.details
            }
          ),
          r || /* @__PURE__ */ e(
            m.Siblings,
            {
              template: "color-swatch",
              ...i
            }
          ),
          /* @__PURE__ */ p("div", { className: "w-full flex flex-col lg:flex-row gap-3 lg:gap-4 justify-between", children: [
            /* @__PURE__ */ e(
              m.Details.Price,
              {
                blueprint: ge.details
              }
            ),
            /* @__PURE__ */ e(
              m.SizePicker,
              {
                template: "modal",
                ...a,
                triggerLabel: "PDP_Add_To_Cart"
              }
            )
          ] }),
          /* @__PURE__ */ e("span", { className: l.returnPolicyWrapper, children: u("Product_Return_Policy") })
        ] }),
        /* @__PURE__ */ e(
          m.ImageGallery,
          {
            template: "keen",
            indicator: "dots",
            blueprint: ge.gallery,
            ...s
          }
        )
      ] });
    }
  )
), Ft = t.object({
  template: t.literal("linz"),
  variants: t.custom().optional()
}), co = P(
  "ProductTemplateAsLinz",
  y(Ft, () => /* @__PURE__ */ p(m.Root, { template: "grid", children: [
    /* @__PURE__ */ e(
      m.ImageGallery,
      {
        template: "keen",
        indicator: "number",
        slidesPerView: { mobile: 1, tablet: 1, desktop: 3 },
        gap: { mobile: 0, tablet: 0, desktop: 0 }
      }
    ),
    /* @__PURE__ */ p("div", { className: "col-span-12 lg:col-start-9 lg:col-end-13 top-0 left-0 row-start-1 row-end-2 flex flex-col p-4 bg-[#aeaeae7d] backdrop-blur-lg rounded-lg sticky right-6 place-self-end w-full order-2 h-fit lg:self-end lg:p-6", children: [
      /* @__PURE__ */ e(m.Details.Name, {}),
      /* @__PURE__ */ e(m.Details.Price, {}),
      /* @__PURE__ */ e(m.Siblings, { template: "image-card" }),
      /* @__PURE__ */ e(m.SizePicker, { template: "button-grid" }),
      /* @__PURE__ */ e(m.AddToCart, { template: "button" })
    ] })
  ] }))
), uo = t.discriminatedUnion("template", [
  Mt,
  Kt,
  Ht,
  Vt,
  Ut,
  $t,
  Ft
]), Zo = P(
  "ProductTemplate",
  y(uo, (a) => a.template === "basic" ? /* @__PURE__ */ e(to, { ...a }) : a.template === "helsinki" ? /* @__PURE__ */ e(ao, { ...a }) : a.template === "malibu" ? /* @__PURE__ */ e(no, { ...a }) : a.template === "vienna" ? /* @__PURE__ */ e(io, { ...a }) : a.template === "graz" ? /* @__PURE__ */ e(ro, { ...a }) : a.template === "salzburg" ? /* @__PURE__ */ e(lo, { ...a }) : a.template === "linz" ? /* @__PURE__ */ e(co, { ...a }) : null)
), qo = (a) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...a,
    children: /* @__PURE__ */ e(
      "path",
      {
        stroke: "#18181B",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "m13.5999 4-7.7 7.7-3.5-3.5"
      }
    )
  }
);
export {
  In as Accordion,
  ds as AddToCart,
  cs as AddToCartButton,
  is as AddToCartQuanityPickerRow,
  rs as AddToCartQuantityPicker,
  as as Attributes,
  Jn as AttributesAsIconBlocks,
  Zn as AttributesAsProgressBar,
  es as AttributesAsRow,
  qn as AttributesAsTags,
  ts as AttributesPropsSchema,
  Qo as AttributesTagsItemSchema,
  to as Basic,
  wn as Brand,
  Sn as BrandSchema,
  zs as Bundle,
  eo as BundlePromoBanner,
  gt as BundleSavingsBadge,
  Vs as BundleUpsell,
  qo as Checkmark,
  un as CrossSvg,
  yn as Description,
  zn as Details,
  vt as FULL_VIEWPORT_DISPLAY_SIZE,
  Us as GiftWithPurchase,
  ro as Graz,
  ao as Helsinki,
  ns as IconMinus,
  ss as IconPlus,
  Fn as ImageGallery,
  Un as ImageGalleryAsGrid,
  Hn as ImageGalleryAsKeen,
  co as Linz,
  no as Malibu,
  fn as Name,
  Nn as Price,
  kn as PriceHistoryDrawer,
  ht as PriceSchema,
  m as Product,
  Zo as ProductTemplate,
  uo as ProductTemplatePropsSchema,
  Bn as ProductType,
  Cs as RelatedProducts,
  xt as RelatedProductsImageCards,
  Ts as RelatedProductsSwiper,
  gn as Root,
  mn as RootAsDrawer,
  pn as RootAsDrawerDialog,
  dt as RootAsDrawerSchema,
  hn as RootAsGrid,
  ut as RootAsGridSchema,
  bn as RootPropsSchema,
  Ue as SHOP_THE_LOOK_ATTRIBUTE_KEY,
  At as STATUS_TRANSLATIONS,
  lo as Salzburg,
  ft as ShopTheLook,
  En as ShopTheLookItem,
  Pn as ShortDescription,
  vn as ShortDescriptionSchema,
  _s as SiblingColorSwatchList,
  ks as Siblings,
  vs as SiblingsImageCard,
  Qs as SizeGuide,
  $s as SizeGuideContent,
  Xs as SizeGuideDrawer,
  Zs as SizeGuideTrigger,
  fs as SizePicker,
  us as SizePickerButtonGrid,
  bs as SizePickerModal,
  Ks as SizeRecommendation,
  js as SizeRecommendationScale,
  Xn as Specifications,
  Yn as SpecificationsAsTable,
  _t as SpecificationsAsTableSchema,
  Is as StickyAddToCart,
  Bs as StickyAddToCartButton,
  It as Swatch,
  Os as UspBlock,
  io as Vienna,
  An as Wrapper,
  Cn as WrapperSchema,
  yt as ZoomCursorOverlay,
  bt as accordionItemSchema,
  Dn as accordionSchema,
  Bt as addToCartButtonSchema,
  Ct as addToCartQuantityPickerSchema,
  Dt as addToCartSchema,
  Nt as attributesAsIconBlocksSchema,
  $e as attributesAsProgressBarSchema,
  Tt as attributesAsRowSchema,
  Fe as attributesAsTagsSchema,
  Qn as attributesProgressBarItemSchema,
  Ln as bundleSavingsBadgeSchema,
  Ve as descriptionSchema,
  Wt as giftWithPurchaseSchema,
  St as imageGalleryAsGridSchema,
  ze as imageGalleryAsKeenSchema,
  wt as imageGalleryPropsSchema,
  pt as nameSchema,
  mt as priceHistoryDrawerSchema,
  Gt as productSizeRecommendationScaleSchema,
  Mt as productTemplateAsBasicSchema,
  Ut as productTemplateAsGrazSchema,
  Kt as productTemplateAsHelsinkiSchema,
  Ft as productTemplateAsLinzSchema,
  Ht as productTemplateAsMalibuSchema,
  $t as productTemplateAsSalzburgSchema,
  Vt as productTemplateAsViennaSchema,
  pe as productTypeSchema,
  Lt as relatedProductsImageCardsSchema,
  ie as relatedProductsSchema,
  Rt as relatedProductsSwiperSchema,
  Rn as shopTheLookItemSchema,
  Gn as shopTheLookSchema,
  zt as siblingColorSwatchListSchema,
  Ye as siblingsImageCardSchema,
  we as siblingsSchema,
  Ot as sizeGuideContentSchema,
  jt as sizeGuideDrawerSchema,
  Le as sizeGuideSchema,
  xe as sizeGuideTriggerSchema,
  Se as sizePickerButtonGridSchema,
  ve as sizePickerModalSchema,
  gs as sizePickerSchema,
  Ms as sizeRecommendationSchema,
  kt as specificationsPropsSchema,
  Et as stickyAddToCartButtonSchema,
  Ds as stickyaddToCartSchema,
  ls as useAddToCartLabel,
  As as useElementVisibility,
  Pt as useImageZoom,
  me as uspBlockSchema
};
//# sourceMappingURL=index.es.js.map
